const leaflets = {
  "crotone": {
    "config": {
      "primary-color": "rgb(0, 135, 60)",
      "secondary-color": "rgb(0, 164, 100)",
      "tertiary-color": "#ffdd00",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
      "clientIcon": require("assets/images/logo-Pam-superstore.png"),
      "serverPath": "pamcrotone.supercentro.interattivo.net/",
      "pdfPath": "/media/pdf/volantino.pdf",
      "shareFlyerTitle": "Dai uno sguardo al nuovo volantino interattivo di PAM Superstore Crotone!",
      "shareFlyerURL": "https://pamcrotone.supercentro.interattivo.net?v=274",
      "shareProductSentence": "Guarda il Volantino di PAM Superstore Crotone!",
      "ogTitleMeta": "PAM Superstore Crotone | Volantino interattivo",
      "ogDescriptionMeta": "Dai uno sguardo al volantino interattivo di PAM Superstore Crotone. Offerte valide dal 14/12 al 27/12",
      "ogImageMeta": "https://pamcrotone.supercentro.interattivo.net/media/images/superstore_fb_7029.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": true,
      "ga_tracking_id": "UA-152069090-40",
      "release_id": "4",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 20,
      "client_id": 31,
      "signboard_id": 48,
      "has_pages": true,
      "hide_grocery_list": false,
      "hide_searchbar": false,
      "hide_listPages": false,
      "line_through": false,
      "category_banner": "",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false
    },
    "leaflet": {
      "name": "7029 Crotone",
      "code": "274",
      "id_campaign": "274",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/Indice-7029-Crotone_nnDGfEN.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 24.993150203955622,
              "left": 11.747055219454746,
              "width": 77.79778520800352,
              "height": 4.740008504066859
            }
          },
          {
            "page": 5,
            "blueprint": {
              "top": 29.779832332861872,
              "left": 11.620569098343758,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 7,
            "blueprint": {
              "top": 35.72141522432222,
              "left": 11.80838587619137,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 8,
            "blueprint": {
              "top": 41.32311558173216,
              "left": 11.60724913887806,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 11,
            "blueprint": {
              "top": 47.12061634746854,
              "left": 11.653848936828075,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 14,
            "blueprint": {
              "top": 52.925625307578635,
              "left": 11.619612896434322,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 17,
            "blueprint": {
              "top": 58.71339898374972,
              "left": 11.744193300453079,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 19,
            "blueprint": {
              "top": 64.61874302811073,
              "left": 11.427509926810853,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 20,
            "blueprint": {
              "top": 70.30353386274349,
              "left": 11.843571431767916,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": 23,
            "blueprint": {
              "top": 76.05506558411886,
              "left": 11.728499553030394,
              "width": 77.79778520800352,
              "height": 5.854248167620193
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://www.volantinointerattivo.net",
            "target": "_blank",
            "blueprint": {
              "top": 5.746088513273424,
              "left": 62.66012629679747,
              "width": 30.0,
              "height": 6.099162621626355
            }
          }
        ]
      },
      "categories": [
        {
          "category_name": "Gastronomia",
          "subcategories": [
            "Formaggi",
            "Salumi",
            "Piatti Pronti",
            "Panetteria"
          ]
        },
        {
          "category_name": "Bevande",
          "subcategories": [
            "Vini e Spumanti",
            "Liquori",
            "Bibite",
            "Succhi",
            "Acqua",
            "Birre"
          ]
        },
        {
          "category_name": "Alimentari",
          "subcategories": [
            "Dispensa",
            "Snack Dolci",
            "Rossi",
            "Olio",
            "Snack Salati",
            "Pasta",
            "Colazione"
          ]
        },
        {
          "category_name": "Self Service",
          "subcategories": [
            "Formaggi",
            "Ittico",
            "Pasta",
            "Salumi",
            "Yogurt",
            "Vegetali",
            "Snack",
            "Latte"
          ]
        },
        {
          "category_name": "Surgelati",
          "subcategories": [
            "Ittico",
            "Verdure",
            "Panati",
            "Preparati",
            "Gelati",
            "Dolci"
          ]
        },
        {
          "category_name": "Ortofrutta",
          "subcategories": [
            "Verdura",
            "Frutta"
          ]
        },
        {
          "category_name": "Macelleria",
          "subcategories": [
            "Avicoli",
            "Bovino",
            "Suino",
            "Altro"
          ]
        },
        {
          "category_name": "Casa e Cucina",
          "subcategories": [
            "Altro",
            "Stoviglie"
          ]
        },
        {
          "category_name": "Piccoli elettrodomestici",
          "subcategories": [
            "Preparazione cibo"
          ]
        },
        {
          "category_name": "No Food",
          "subcategories": [
            "Home"
          ]
        },
        {
          "category_name": "Igiene Casa",
          "subcategories": [
            "Extra",
            "Stoviglie",
            "Bucato",
            "Superfici"
          ]
        },
        {
          "category_name": "Igiene Persona",
          "subcategories": [
            "Corpo",
            "Viso",
            "Intima",
            "Capelli",
            "Orale"
          ]
        },
        {
          "category_name": "Giochi e Giocattoli",
          "subcategories": [
            "Bambole e Peluche",
            "Altro",
            "Giochi di Società"
          ]
        }
      ],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0001_4PMoHAb.jpg",
          "products": [
            {
              "item_id": "134707",
              "field1": "parmigiano reggiano dop",
              "field2": "stagionato 24 mesi",
              "field3": "l'etto",
              "field4": "",
              "description": "parmigiano reggiano dop stagionato 24 mesi l'etto",
              "grammage": 1000,
              "price": "1.19",
              "price_label": "€ 1,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 24.573665254911337,
                "left": 1.8035764179938534,
                "width": 31.53303995529477,
                "height": 33.75292095706753
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/logo_parmigiano_reggiano_1526023058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/parmigiano_pezzi_auchan_1521041260_1540980547_1558444713.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/22760_1574332008.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606141898.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_rId73h2_LiRN52L.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.parmigianoreggiano.com/it/"
                }
              ]
            },
            {
              "item_id": "164080",
              "field1": "fontanafredda ",
              "field2": "spumante asti docg",
              "field3": "cl. 75",
              "field4": "",
              "description": "fontanafredda  spumante asti docg cl. 75",
              "grammage": 750,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 24.573665254911337,
                "left": 33.33661637328863,
                "width": 25.910868957809456,
                "height": 33.75292095706753
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Asti_Fontanafredda_75_cl_1430228017_1520446213.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_oYQS2Fa_Audss8q.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "ASTI DOCG",
                  "data": {
                    "specifiche": "Uva da cui è prodotto: Moscato Bianco, Tipo di vinificazione: metodo charmat, Temperatura di servizio: 7 – 8° C, Gradazione alcolica: 7% vol., Volumi disponibili: 0,75 lt / 1,5 lt",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/Asti_Fontanafredda_75_cl_1430228017_1520446213.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "165804",
              "field1": "Maina pandoro e Balocco panettone",
              "field2": "",
              "field3": "kg. 1",
              "field4": "",
              "description": "Maina pandoro e Balocco panettone kg. 1",
              "grammage": null,
              "price": "1.98",
              "price_label": "€ 1,98",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 20.879841326877447,
                "left": 59.33384332925337,
                "width": 39.085985312117494,
                "height": 37.43248380891341
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3234034_Maina_pandoro_Kg1_1574329950_1605717774.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_5wcQOfk_0fg0TVj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/video/Spot_2018_Pandoro_Maina.mp4"
                }
              ]
            },
            {
              "item_id": "237688",
              "field1": "le cadeau",
              "field2": "valigetta gioiello",
              "field3": "",
              "field4": "",
              "description": "le cadeau valigetta gioiello",
              "grammage": null,
              "price": "8.99",
              "price_label": "€ 8,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 58.45634071488235,
                "left": 0.0,
                "width": 57.12627498980007,
                "height": 35.9636955592194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3263873_Le_cadeau_strenna_GIOIELLO_PANDORO_6PZ_1604475555.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_PtgM6fa_f50d64X.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-bauli pandoro cellophane gr. 500, -baratti & milano cioccolato bianco con champagne e ribes nero di gr. 75, -sperlari confezione morbidelli gr. 90, -sperlari sacchetto morbide gelatine alla frutta gr. 100, -fiore confezione cantucci al cioccolato gr. 100, -la sassellese confezione canestrelli gr. 80                                      ",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3263873_Le_cadeau_strenna_GIOIELLO_PANDORO_6PZ_1604475555_1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "132556",
              "field1": "rovagnati ",
              "field2": "prosciutto cotto gran biscotto ",
              "field3": "l'etto",
              "field4": "",
              "description": "rovagnati  prosciutto cotto gran biscotto  l'etto",
              "grammage": 100,
              "price": "1.69",
              "price_label": "€ 1,69 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 58.45634071488235,
                "left": 57.12627498980005,
                "width": 42.873725010199934,
                "height": 35.9636955592194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Granbiscotto_rovagnati_1520522013.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Gran-Biscotto-Arrosto_1574239326.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jro5uP6_E52xsOb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.rovagnati.it/it/prodotti/prosciutti-cotti/10/gran-biscotto-classico"
                }
              ]
            }
          ]
        },
        {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0002_ggRtkH1.jpg",
          "products": [
            {
              "item_id": "197377",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.0360804843460323,
                "left": 3.997994115793665,
                "width": 45.32659590400778,
                "height": 37.03459804160035
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3249133_Villa_guelfa_vassoio_GASTRONOMICO_11_PZ_1605809913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_l50xAwN_xrW7Zda.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": " -cantine cav. ceste bottiglia merlot cl. 750, -salumificio vecchi,scatola cotechino cotto al vapore  gr. 450, -molino di borgo s. dalmazzo sacchetto lenticchie portafortuna gr. 150, -salumificio gonella  specialità salame al barolo gr. 125 ca., -l'antica madia confezione gnocchetti pasta trafilata al bronzo gr. 250, -saporie,vaso sugo alla contadina gr. 185, -monviso group astuccio rabatin al gorgonzola dop gr. 50, -caffè corsini astuccio caffè pregiata miscela gr. 100, -la sassellese,scatola ciambelle al moscato gr. 90, -molino filippini  confezione polenta del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3249133_Villa_guelfa_vassoio_GASTRONOMICO_11_PZ_1605809913_9K5iu7y.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239402",
              "field1": "regalidea",
              "field2": "vassoio onice",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio onice",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.3767813513572484,
                "left": 50.511219910240726,
                "width": 49.488780089759274,
                "height": 36.69808968406641
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3254412_r.idea_vassoio_ONICE_PANDORO_7_PEZZI_1605813468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_kqtqOrW_JP93OZL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-melegatti pandoro incartato a mano gr. 500, -gli artigiani della pasta fusilli gr. 250, -fiore cantuccini con gocce di cioccolato gr. 100, -caffarel praline le perle gr. 80, -casa sant'orsola spumante dolce cuvée vol 9,5% cl. 75, -lindor cioccolato fondente gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3254412_r.idea_vassoio_ONICE_PANDORO_7_PEZZI_1605813468_2Mb4tB9.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239405",
              "field1": "le cadeau",
              "field2": "vassoio merry christmas",
              "field3": "",
              "field4": "",
              "description": "le cadeau vassoio merry christmas",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.68686613946282,
                "left": 50.64290085679313,
                "width": 49.35709914320685,
                "height": 27.80619428166187
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252120_Lecadeau_vassoio_MERRY_CHRISTMAS_PANETTONE_7_PZ_1605810290.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jdqBuyD_yDy337u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "- bauli panettone incarto a mano gr. 500, -sant’orsola spumante millesimato cuvèe dolce  9.5° ml. 750, -baratti & milano tavoletta cioccolato extra fondente 70% gr. 75, -motta sacchetto boules ripiene crema di nocciole gr. 85, - sperlari sacchetto morbide gelatine alla frutta gr. 100, -virginia confezione pasticcini panna e amarena gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252120_Lecadeau_vassoio_MERRY_CHRISTMAS_PANETTONE_7_PZ_1605810290_kN4Hzqj.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "197299",
              "field1": "villa guelfa",
              "field2": "cassetta in legno contadina",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cassetta in legno contadina",
              "grammage": null,
              "price": "27.90",
              "price_label": "€ 27,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.68686613946282,
                "left": 4.082109343125255,
                "width": 46.56079151366789,
                "height": 28.17339134408537
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252493_Villa_guelfa_CASETTA_CONTADINA_10_PZ_1605812654.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_w7CF62r_ScF8PYp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-bottiglia cabernet  cantine cav. ceste cl. 75, -scatola cotechino cotto al vapore salumificio vecchi gr. 450, -specialità salame al barolo salumificio gonella gr. 125 ca., -sacchetto lenticchie portafortuna molino di borgo s. dalmazzo gr. 150, -trancio grana padano dop virgilio gr. 150, -astuccio rabatin al gorgonzola dop monviso group gr. 50, -confezione pasta di gragnano igp i fidanzati capresi  il vecchio pastificio di gragnano gr. 250, -vaso sugo di pomodoro fresco dell' emilia romagna  le conserve della nonna gr. 190, -confezione specialità minestrone del contadino  molino di borgo s. dalmazzo gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252493_Villa_guelfa_CASETTA_CONTADINA_10_PZ_1605812654_5ypcoeC.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239406",
              "field1": "le cadeau",
              "field2": "cesto verde smeraldo",
              "field3": "",
              "field4": "",
              "description": "le cadeau cesto verde smeraldo",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 68.8602574835482,
                "left": 4.082109343125255,
                "width": 46.56079151366789,
                "height": 28.130158227518056
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252138_Lecadeau_cesto_VERDE_SMERALDO_PANETTONE_14_PZ_1605810627.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dc3QJDC_Ksuj1az.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": " -complemento d’arredo in velluto verde,  -bauli panettone incartato a mano gr. 750, -sant’orsola spumante millesimato cuvée dolce 9.5° cl.75, -sant’orsola bottiglia sangiovese  11.5° cl. 75, -baratti & milano cioccolato bianco con foglie di menta piperita gr. 75, -giglio sacchetto croccantino ricoperto di cioccolato gr. 100, -ricciarelli scatola alle mandorle fiore gr. 72, -virginia confezione pasticcini pera e cioccolato gr. 80, -piatti d’autore scatola cotechino cotto gr. 250, -tenuta del cervo sacchetto lenticchie gr. 175, -dalla costa confezione pasta pennoni gr. 250, -tenuta del cervo vaso sugo ai funghi porcini gr. 185, -bontàloro misto funghi secchi con porcini gr. 15, -corsini astuccio caffè gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252138_Lecadeau_cesto_VERDE_SMERALDO_PANETTONE_14_PZ_1605810627_L6foGUC.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "164065",
              "field1": "regalidea",
              "field2": "vassoio rustico con pandoro",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio rustico con pandoro",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 68.8602574835482,
                "left": 50.64290085679313,
                "width": 49.35709914320685,
                "height": 28.130158227518056
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252004_r.idea_vassoio_RUSTICO_PANDORO_9_PEZZI_1605809968.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jFXXHks_OsDDvcR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-1 vassoio decorato -gli artigiani della pasta fusilli gr. 250, -sfiziosi schiacciatine classiche gr. 100, -casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, -cotechino cotto gr. 250, -lenticchie della tradizione gr. 150, -melegatti pandoro incartato a mano gr. 500, -salame nostrano gr. 100, -caffarel praline le perle gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252004_r.idea_vassoio_RUSTICO_PANDORO_9_PEZZI_1605809968.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0003_AyOjag6.jpg",
          "products": [
            {
              "item_id": "197294",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.4991803721650823,
                "left": 2.0797633618931064,
                "width": 48.30365157078743,
                "height": 36.82048870487424
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3261237_Villa_guelfa_vassoio_DEL_CONVIVIO_7_PZ_1605814262.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GQIgrll_1X8cIlT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "",
                  "data": {
                    "specifiche": "-pasticceria vergani  panettone classico di milano gr. 750, -cantine cav. ceste  bottiglia cabernet cl. 75, -l'antica madia confezione conchiglioni  pasta trafilata in bronzo gr. 250, -saporie vaso sugo ai funghi gr. 185, -monviso group astuccio langhetti artigianali all’olio di oliva gr. 100, -molino di borgo s. dalmazzo confezione specialità minestrone del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3261237_Villa_guelfa_vassoio_DEL_CONVIVIO_7_PZ_1605814262_oIrDymP.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "165815",
              "field1": "maina",
              "field2": "grandi emozioni",
              "field3": "",
              "field4": "",
              "description": "maina grandi emozioni",
              "grammage": null,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.4991803721650823,
                "left": 50.38341493268054,
                "width": 45.66615667074663,
                "height": 36.82048870487424
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3248893_Grandi_Emozioni_Pandoro_1605795903.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3248894_Grandi_Emozioni_Panettone_1605795972.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_boF2MSo_V04NSGA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-panettone gr. 750 + sant'orsola spumante cl. 75, -pandoro gr. 700 + sant'orsola spumante cl. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3248893_Grandi_Emozioni_Pandoro_1605795903_ELEgt8e.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239408",
              "field1": "villa guelfa",
              "field2": "cesto p.duomo",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cesto p.duomo",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.31966907703932,
                "left": 48.27651978784171,
                "width": 47.77305181558547,
                "height": 28.418189385701037
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3249112_Villa_guelfa_cesto_DUOMO_PANETTONE_14_PZ_1605809388.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DE0jelL_0CR9YKM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "",
                  "data": {
                    "specifiche": " -cesto rettangolare in vimini verniciato con riflessi oro -panettone classico milanese,incartato a mano tre marie,gr. 750, -bottiglia spumante dolce millesimato 2019 cantine cav. ceste,ml. 750, -bottiglia cabernet, - cantine cav. ceste,ml. 750, -tavoletta cioccolato extra fondente con granella di caffè arabica  baratti & milano,gr. 75, -scatola pasticcini ricoperti al cioccolato fondente la sassellese,gr. 100, -scatola cotechino cotto al vapore  salumificio vecchi,gr. 450, -sacchetto lenticchie portafortuna  molino di borgo s. dalmazzo,gr. 150, -confezione pasta di gragnano igp i fidanzati capresi il vecchio pastificio di gragnano,gr. 250, -vaso sugo ai funghi  saporie,gr. 185, -astuccio pasticcini ripieni con crema alla nocciola  monviso group,gr. 150, -stecca torrone tenero ricoperto al cacao i siciliani,gr. 100, -ballotin cioccolatini classici  caffarel,gr. 80, -vaso squisita crema di nocciole  casa costa,gr. 200",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3249112_Villa_guelfa_cesto_DUOMO_PANETTONE_14_PZ_1605809388_5B5K9oh.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239410",
              "field1": "villa guelfa",
              "field2": " -cesto rettangolare in vimini con intreccio in stoffa ",
              "field3": "",
              "field4": "",
              "description": "villa guelfa  -cesto rettangolare in vimini con intreccio in stoffa ",
              "grammage": null,
              "price": "74.90",
              "price_label": "€ 74,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 68.73785846274036,
                "left": 48.27651978784171,
                "width": 47.77305181558547,
                "height": 28.497355289941563
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3254280_Villa_guelfa_cesto_MILANO_PANDORO_E_PANETTONE_14_PZ_1605812874.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DG5R6An_6EusXY9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-pandoro alto classico incartato a mano tre marie,gr. 750, -panettone classico milanese,incartato a mano  tre marie,gr. 750, -bottiglia spumante rosé millesimato 2019  cantine cav. ceste,ml. 750, -scatola cotechino cotto al vapore  salumificio vecchi gr. 450, -sacchetto lenticchie portafortuna  molino di borgo s. dalmazzo,gr. 150, -confezione gnocchetti,pasta trafilata al bronzo  l'antica madia gr. 250, -lattina caffè macinato monoarabica  illycaffè,gr. 125,\n-astuccio finissimi canestrellini  la sassellese  gr. 125, -scatola biscotti assortiti al cioccolato e uvetta  l’albereto,gr. 150, -vaso confettura di amarene  capricci di gola,gr. 220, -tavoletta cioccolato extra fondente con granella di caffè arabica  baratti & milano,gr. 75, -stecca torrone tenero alle mandorle  i siciliani gr. 100, -cornet praline assortite lindor  lindt,gr. 200",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3254280_Villa_guelfa_cesto_MILANO_PANDORO_E_PANETTONE_14_PZ_1605812874_ibYoemF.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239409",
              "field1": "villa guelfa",
              "field2": "cesto gran galà con manici in vimini verniciato ",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cesto gran galà con manici in vimini verniciato ",
              "grammage": null,
              "price": "59.90",
              "price_label": "€ 59,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 68.73785846274036,
                "left": 1.8435332517339862,
                "width": 46.432986536107705,
                "height": 28.497355289941563
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3249108_Villa_guelfa_cesto_GRAN_GALA_PANETTONE_16_PZ_1605796067.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_s4GVjbe_UpWpdXo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-panettone limoncello,incartato a mano, - giovanni cova & c. gr. 750, -bottiglia spumante dolce millesimato 2019  cantine cav. ceste ml. 750, -bottiglia cabernet  cantine cav. ceste ml. 750, -specialità salame al barolo  salumificio gonella gr. 125 ca., -scatola cotechino cotto al vapore  salumificio vecchi gr. 450, -sacchetto lenticchie portafortuna  molino di borgo s. dalmazzo gr. 150 , -confezione gigli,tradizionale pasta ligure  alta valle scrivia gr. 250, -vaso sugo con funghi  abbazia san frontiniano gr. 290, -confezione polenta ai funghi porcini  cordero gr. 160, -scatola ciambelle al moscato la sassellese gr. 90, -astuccio caffè pregiata miscela  caffè corsini gr. 100, -tarallini di alberobello  nonna marietta gr. 100, -stecca torrone tenero alle mandorle  i siciliani gr. 100, -tavoletta cioccolato extra fondente 88%  baratti & milano gr. 75, -confezione praline al moscato d’asti docg  mandrile & melis gr. 120",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3249108_Villa_guelfa_cesto_GRAN_GALA_PANETTONE_16_PZ_1605796067_3IC1Cd6.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239407",
              "field1": "le cadeau",
              "field2": "cesto portofino",
              "field3": "",
              "field4": "",
              "description": "le cadeau cesto portofino",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.68686613946282,
                "left": 1.8435332517339862,
                "width": 46.432986536107705,
                "height": 28.050992323277534
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252142_Lecadeau_cesto_PORTOFINO_PANDORO_17_PZ_1605810693.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jFXifpl_UgwoEWd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-complemento d’arredo in stoffa con manici -tre marie panettone basso incartato a mano gr. 750, -mionetto bottiglia spumante vivo cuvée blanc 11°ml. 750, -cástano bottiglia vino merlot 11° ml. 750, -vanoir astuccio pasticcini al cioccolato gr. 100, -baratti & milano tavoletta cioccolato pere,mandorle e miele gr. 75, -sperlari sacchetto morbide gelatine alla frutta gr. 100, -sperlari astuccio torrone alla mandorla gr. 75, -dalla costa n° 2 confezioni pasta pennoni gr. 250, -tenuta del cervo vaso sugo ai funghi porcini gr. 185, -bellucci scatola cotechino cotto gr. 250, -tenuta del cervo sacchetto lenticchie gr. 175, -bontàloro misto funghi secchi con porcini gr. 15, -motta sacchetto boules ripiene crema di nocciole gr. 85, -corsini astuccio caffè gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252142_Lecadeau_cesto_PORTOFINO_PANDORO_17_PZ_1605810693_1noIUWP.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0004_ufCuEnZ.jpg",
          "products": [
            {
              "item_id": "197289",
              "field1": "balocco",
              "field2": "dolci emozioni",
              "field3": "",
              "field4": "",
              "description": "balocco dolci emozioni",
              "grammage": null,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.110366751457929,
                "left": 4.345471236230111,
                "width": 57.62586699306406,
                "height": 37.23091888386505
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3261049_DolciEmozioni_PNT_8001100069838_1605813759.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3261050_DolciEmozioni_PND_8001100069845_1605813812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_klMjccC_RhExtVl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-balocco dolci emozioni valigetta 4 pezzi con pandoro gr. 750, -balocco dolci emozioni valigetta 4 pezzi con panettone mandorlato  gr. 750, -sant'orsola spumante cl. 75,  -lindor tavoletta cioccolato al latte gr. 100, -vergani torrone gr. 75                                    ",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3261049_DolciEmozioni_PNT_8001100069838_1605813759_HmGc4EL.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "164122",
              "field1": "regalidea",
              "field2": "valigetta dolci auguri",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta dolci auguri",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 2.873666818192645,
                "left": 55.98437019646375,
                "width": 43.149933323520415,
                "height": 37.33521020519957
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3254291_r.idea_STRENNA_DOLCI_AUGURI_PANDORO_5_PEZZI_1605813349.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_3FoWL3V_WWAFVsg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": " -casa sant'orsola spumante dolce cuvée vol 9,5% cl.75 sapori cantuccini con gocce di cioccolato gr. 100, -melegatti pandoro / panettone gr. 500, -cuor di langhe praline al latte crema nocciola gr. 70, -lindt cioccolato latte gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3254291_r.idea_STRENNA_DOLCI_AUGURI_PANDORO_5_PEZZI_1605813349.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239401",
              "field1": "regalidea",
              "field2": "vassoio bellini",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio bellini",
              "grammage": null,
              "price": "17.90",
              "price_label": "€ 17,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.20887702339222,
                "left": 51.112175174023946,
                "width": 48.022128345960226,
                "height": 28.148265926991368
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3254290_r.idea_cesto_BELLINI_PANDORO_7_PEZZI_1605812798.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WyRUniv_IxSN5Sz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-sapori cantuccini con gocce di cioccolato gr. 100, -lindt cioccolato al latte lindor gr. 100, -bauli pandoro classico gr. 500, -sperlari torrone tenero alla mandorla gr. 75 -casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, -baratti babette caramelle gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3254290_r.idea_cesto_BELLINI_PANDORO_7_PEZZI_1605812798.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239404",
              "field1": "lecadeau",
              "field2": "strenna caffarel con particolare scatola a cuspide",
              "field3": "",
              "field4": "",
              "description": "lecadeau strenna caffarel con particolare scatola a cuspide",
              "grammage": null,
              "price": "23.90",
              "price_label": "€ 23,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.20887702339222,
                "left": 4.324022002236307,
                "width": 46.788153171787634,
                "height": 28.148265926991368
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3259384_Le_cadeau_strenna_CAFFAREL_PANETTONE_5_PZ_1605813728.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GJrGQip_Isid0Mb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-caffarel panettone cellophane gr. 750 -ca’ de medici  spumante cuveè blanc de blancs 11° ml. 750 -caffarel tavoletta cioccolato fondente gr. 80 -caffarel confezione le perle di cioccolato gr. 93, -caffarel scatola gelatine alla frutta gr. 93",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3259384_Le_cadeau_strenna_CAFFAREL_PANETTONE_5_PZ_1605813728.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239403",
              "field1": "regalidea",
              "field2": "valigetta lavazza",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta lavazza",
              "grammage": null,
              "price": "22.90",
              "price_label": "€ 22,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 68.96234511240303,
                "left": 3.6055051550187165,
                "width": 46.67930492258609,
                "height": 31.03765488759697
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3263899_r.idea_STRENNA_LAVAZZA_PANETTONE_6_PEZZI_1605814233.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vugLXcH_OZMDXqq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-casa sant'orsola spumante dolce cuvée vol 9,5%  cl.75, -lavazza caffè tierra brasile gr. 180, -balocco panettone gr. 500 -lavazza caffè tierra perù gr.180, -lavazza caffè oro d'altura gr. 250, -baratti cioccolato extra fondente 70% gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3263899_r.idea_STRENNA_LAVAZZA_PANETTONE_6_PEZZI_1605814233_1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239400",
              "field1": "parmigiano reggiano",
              "field2": "valigetta gran gourmet",
              "field3": "",
              "field4": "",
              "description": "parmigiano reggiano valigetta gran gourmet",
              "grammage": null,
              "price": "20.90",
              "price_label": "€ 20,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 68.35714295038356,
                "left": 50.58545138781423,
                "width": 49.41454861218577,
                "height": 30.908462924769427
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3252076_Lecadeau_valigetta_GRAN_GOURMET_10_PZ_1605810219.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_IxhwWCH_vBsDak1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "-coltellino taglia formaggio del consorzio del parmigiano reggiano -mini ricettario del consorzio del parmigiano reggiano, -trancio di parmigiano reggiano dop stagionato 30 mesi gr. 150, -cà de medici bottiglia lambrusco reggiano doc 11° ml. 750, -la loggia dei grani n° 2 confezioni pasta le casarecce gr. 250, -tenuta del cervo vaso sugo al parmigiano reggiano gr. 190, -antichi sapori d’italia salame del contadino gr. 100, -tenuta del cervo granelli al parmigiano reggiano gr. 100, -l’aceto reale bottiglia aceto balsamico di modena ml. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/3252076_Lecadeau_valigetta_GRAN_GOURMET_10_PZ_1605810219.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0005_XrXyQX1.jpg",
          "products": [
            {
              "item_id": "166083",
              "field1": "bauli",
              "field2": "panettone di verona zero canditi",
              "field3": "kg. 1",
              "field4": "",
              "description": "bauli panettone di verona zero canditi kg. 1",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.1184648598082947,
                "left": 1.7118523051815586,
                "width": 28.213916217244925,
                "height": 19.770152031256575
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8001720021209__PANETTONE_DI_VERONA_1000G_H_1573487608.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9Obg8xp_95TBuXI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165807",
              "field1": "bauli",
              "field2": "il budino",
              "field3": "gr. 750",
              "field4": "",
              "description": "bauli il budino gr. 750",
              "grammage": 750,
              "price": "3.69",
              "price_label": "€ 3,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 22.88861689106487,
                "left": 1.7118523051815586,
                "width": 28.213916217244925,
                "height": 17.316751273516985
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8001720312178__IL_BUDINO_750G_H_1573487624.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vZrepXz_DYAewCK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197283",
              "field1": "motta",
              "field2": "panettone gran cremoso",
              "field3": "gr. 800",
              "field4": "-caramello -panna e cioccolato",
              "description": "motta panettone gran cremoso gr. 800 -caramello -panna e cioccolato",
              "grammage": 800,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Caramello",
                "Panna e cioccolato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 16.768665850673194,
                "left": 29.925768522426484,
                "width": 25.90695281580281,
                "height": 23.43670231390866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8034097875274_GRANCREMOSO_PANETTONE_AL_CARAMELLO_800G_H_1605718143.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8034097875298_GRANCREMOSO_PANETTONE_PANNA_E_CIOCCOLATO_800G_H_1605718159.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_lm5a7Bh_QJNy96r.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165808",
              "field1": "maina",
              "field2": "pandoro gr. 750 -bavarese -limon crema",
              "field3": "panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "field4": "",
              "description": "maina pandoro gr. 750 -bavarese -limon crema panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "grammage": null,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pandoro",
                "Bavarese",
                "Limon crema",
                "Panettone",
                "Crema al cioccolato",
                "Crema pasticcera"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 55.8327213382293,
                "width": 40.59192519317312,
                "height": 15.35836694059165
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3240740_MAINA_Crema_al_cioccolato_pnt_gr.800_1542108609.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3242086_MAINA_Crema_pasticcera_pnt_gr.800_1542108619.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/thumb_1573489741.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3234040_Il_Golosone_Limoncrema_2020_1605795730.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_7BqF9HB_0JK5cCF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239399",
              "field1": "balocco",
              "field2": "pandoro",
              "field3": "cioco party",
              "field4": "gr. 800",
              "description": "balocco pandoro cioco party gr. 800",
              "grammage": 800,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 18.17354441917182,
                "left": 55.8327213382293,
                "width": 40.59192519317312,
                "height": 21.728536364181913
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Balocco_Ciokoparty_800g_1573644422_1605714251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_36aDCtx_4YS7xd6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197288",
              "field1": "giovanni cova & c. ",
              "field2": "- pandoro classico incartato a mano ",
              "field3": "-panettone classico incartato a mano",
              "field4": "kg. 1",
              "description": "giovanni cova & c.  - pandoro classico incartato a mano  -panettone classico incartato a mano kg. 1",
              "grammage": 0,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pandoro",
                "Panettone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.81736326862103,
                "left": 1.7118523051815586,
                "width": 18.86456901202257,
                "height": 18.42376280237041
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3259263_Cova_pandoro_incartato_kg.1_1605813534.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3261136_Cova_panettone_incartato_kg.1_1605813892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_lLhRaO4_C0th6sd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "167085",
              "field1": "tre marie",
              "field2": "-panettone milanese classico/senza canditi kg. 1",
              "field3": "-pandoro il magnifico classico kg. 1",
              "field4": "",
              "description": "tre marie -panettone milanese classico/senza canditi kg. 1 -pandoro il magnifico classico kg. 1",
              "grammage": 0,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pandoro",
                "Panettone Classico",
                "Panettone senza canditi"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.81736326862103,
                "left": 20.57642131720413,
                "width": 18.532819808866865,
                "height": 18.42376280237041
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3231800_TRE_MARIE_Pandoro_Magnifico_KG.1_1573488419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/tre_marie_il_panettone_milanese_basso_750_gr_1573488484.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/tre_marie_il_panettone_milanese_senza_canditi_1_kg_1573488496.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_CWotKdo_Q6YUZaV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165812",
              "field1": "giovanni cova & c.",
              "field2": "panettone pistacchio incartato a mano",
              "field3": "kg. 1",
              "field4": "",
              "description": "giovanni cova & c. panettone pistacchio incartato a mano kg. 1",
              "grammage": 0,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.81736326862103,
                "left": 39.24092207262342,
                "width": 18.732888065470142,
                "height": 18.42376280237041
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3259265_Cova_panettone_Pistacchio_kg.1_1605813599.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WDGveHM_guM1xK8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165809",
              "field1": "bauli",
              "field2": "pandoro con crema baileys",
              "field3": "gr. 750",
              "field4": "",
              "description": "bauli pandoro con crema baileys gr. 750",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.81736326862103,
                "left": 57.97381013809356,
                "width": 18.796181701971722,
                "height": 18.42376280237041
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8001720416340__PANDORO_BAILEYS_750G_H_1573489797.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3259236_BAULI_PANDORO_BAILEYS_750G_HR_1605813403.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_OWqt04D_TdlVuZs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165810",
              "field1": "paluani",
              "field2": "profiteroles di pasticceria",
              "field3": "gr. 750",
              "field4": "",
              "description": "paluani profiteroles di pasticceria gr. 750",
              "grammage": 750,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.81736326862103,
                "left": 76.76999184006527,
                "width": 19.259611851679853,
                "height": 18.42376280237041
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PALUANI_PROFITEROLES_di_Pasticceria_750g_1542108805.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/2121404_PALUANI_FETTA_PROFITEROLES_1573470204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_B87wDtW_1N9JDAh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240323",
              "field1": "caffe' italia",
              "field2": "pitta n'chiusa ",
              "field3": "latta",
              "field4": "kg.1 ",
              "description": "caffe' italia pitta n'chiusa  latta kg.1 ",
              "grammage": 1000,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 75.453182374541,
                "width": 20.57642131720413,
                "height": 18.78553952321099
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/caffe_italia_LOGO_2020_1606237692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CAFFE_ITALIA_PITTA_NCHIUSA_LATTA_KG.1_19.90_1606237693.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PITTA_NCHIUSA_KG.1_LATTA_CAFFE_ITALIA_19.90_1606237694.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_V8UIYGo_UiNDTZ6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240330",
              "field1": "caffe' italia",
              "field2": "torroncini misti bianchi/neri ",
              "field3": "gr.200",
              "field4": "",
              "description": "caffe' italia torroncini misti bianchi/neri  gr.200",
              "grammage": 200,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianchi",
                "Neri"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 58.50053392430326,
                "width": 16.95264845023773,
                "height": 18.78553952321099
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/caffe_italia_LOGO_2020_1606240242.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CAFFE_ITALIA_TORRONE_GR.200_5.49_1606240243.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_HIvNcRN_HUY3PGg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239949",
              "field1": "rienzi                                                                      ",
              "field2": "susumelle  ",
              "field3": "-bianche -cioccolato",
              "field4": "gr.300",
              "description": "rienzi                                                                       susumelle   -bianche -cioccolato gr.300",
              "grammage": 300,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianche",
                "Cioccolato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 39.50428396572827,
                "width": 18.996249958574996,
                "height": 18.78553952321099
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rienzi_susumelle_nere_gr.300_1606500697.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_IpGhEeY_Kq7BmgK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239939",
              "field1": "burlato                                 ",
              "field2": "pitta 'mpigliata",
              "field3": "gr. 380   ",
              "field4": "",
              "description": "burlato                                  pitta 'mpigliata gr. 380   ",
              "grammage": 380,
              "price": "5.90",
              "price_label": "€ 5,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 20.57642131720412,
                "width": 18.927862648524147,
                "height": 18.78553952321099
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PITTA_1606500905.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pitta_mpigliata_2_1606500939.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ExcbEDj_6P2Rf5Q.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165835",
              "field1": "rocher ",
              "field2": "scatola",
              "field3": "x 24 gr. 300",
              "field4": "",
              "description": "rocher  scatola x 24 gr. 300",
              "grammage": 300,
              "price": "6.59",
              "price_label": "€ 6,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 1.9752141982864062,
                "width": 18.601207118917714,
                "height": 18.78553952321099
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/T24_Rocher_1542992428.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aVipcN0_UgxDF6W.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197306",
              "field1": "prestige",
              "field2": "scatola x 28 - gr. 319",
              "field3": "",
              "field4": "",
              "description": "prestige scatola x 28 - gr. 319",
              "grammage": 319,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 78.02666559420243,
                "left": 1.9752141982864062,
                "width": 18.601207118917714,
                "height": 18.54616182317824
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FERRERO_PRESTIGE_T28X4_CARTIER_1542734605_1573490618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_qGriuQv_9k2rkrZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240325",
              "field1": "gusto calabro",
              "field2": "pitta n'chiusa ",
              "field3": "kg.1",
              "field4": "",
              "description": "gusto calabro pitta n'chiusa  kg.1",
              "grammage": 1000,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.02666559420243,
                "left": 20.57642131720412,
                "width": 10.105239229511499,
                "height": 18.54616182317824
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_PITTA_NCHIUSA_KG.1_16.90_1606238762.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606238763.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gimR2qL_EdOOey9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240326",
              "field1": "gusto calabro",
              "field2": "pitta n'chiusa ",
              "field3": "gr.500",
              "field4": "",
              "description": "gusto calabro pitta n'chiusa  gr.500",
              "grammage": 500,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.02666559420243,
                "left": 30.681660546715616,
                "width": 10.963712218876914,
                "height": 18.54616182317824
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_PITTA_NCHIUSA_GR.500_8.90_1606239128.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606239129.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_EUygL5u_zjs8Zz6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240329",
              "field1": "gusto calabro",
              "field2": "crustoli ",
              "field3": "gr.500",
              "field4": "",
              "description": "gusto calabro crustoli  gr.500",
              "grammage": 500,
              "price": "6.90",
              "price_label": "€ 6,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.39386265662593,
                "left": 41.64537276559253,
                "width": 10.105239229511499,
                "height": 18.17896476075474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_CRUSTOLI_GR.500_6.90_1606240180.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606240181.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_s4njyib_bCDPwFs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240327",
              "field1": "gusto calabro",
              "field2": "susumelle classiche ",
              "field3": "-nere -bianche e nere ",
              "field4": "gr.500",
              "description": "gusto calabro susumelle classiche  -nere -bianche e nere  gr.500",
              "grammage": 500,
              "price": "7.50",
              "price_label": "€ 7,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Nere",
                "Bianche e nere"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.39386265662593,
                "left": 51.75061199510404,
                "width": 17.81112143960315,
                "height": 18.17896476075474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_SUSUMELLE_CLASSICHE_BIANCHE-NERE_GR.500_7.50_1606239395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_SUSUMELLE_CLASSICHE_NERE_GR.500_7.50jpg_1606239395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606239396.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_tD1nQ4q_r7nfEtQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240328",
              "field1": "gusto calabro",
              "field2": "susumelle ripiene ",
              "field3": "-al cioccolato -alla nocciola -al pistacchio ",
              "field4": "gr.500",
              "description": "gusto calabro susumelle ripiene  -al cioccolato -alla nocciola -al pistacchio  gr.500",
              "grammage": 500,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Al cioccolato",
                "Alla nocciola",
                "Al pistacchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.39386265662593,
                "left": 69.56173343470718,
                "width": 10.63196301572121,
                "height": 18.17896476075474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_SUSUMELLE_RIPIENE_GR.500_8.90_1606239697.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606239699.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_obo67v8_sADk7Kp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240312",
              "field1": "gusto calabro",
              "field2": "panettone classico ",
              "field3": "kg.1",
              "field4": "",
              "description": "gusto calabro panettone classico  kg.1",
              "grammage": 1000,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.39386265662593,
                "left": 80.19369645042839,
                "width": 15.572545348211879,
                "height": 18.17896476075474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GUSTO_CALABRO_PANETTONE_CLASSICO_KG.1_19.90__1606235212.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_GUSTO_CALABRO_1606235212.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8kwEF5x_pYtPHO8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 6,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0006_Y8taghg.jpg",
          "products": [
            {
              "item_id": "197311",
              "field1": "novella",
              "field2": "conserve in olio",
              "field3": "vaso gr. 980",
              "field4": "-fantasia di funghi con porcini -antipasto ortolano -olive verdi giganti denocciolate",
              "description": "novella conserve in olio vaso gr. 980 -fantasia di funghi con porcini -antipasto ortolano -olive verdi giganti denocciolate",
              "grammage": 980,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Funghi",
                "Antipasto ortolano",
                "Olive verdi"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.2714636358181,
                "left": 52.0139738882089,
                "width": 45.727482108717794,
                "height": 18.301363781562575
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/novella_funghi_con_porcini_1596807088.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/novella_ortolano_1596807091.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NOVELLA_g980_OLIVE_GIG_DENOCCIOLATE_1606381109.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_djTGcTV_bS7whL7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166848",
              "field1": "excelsior ",
              "field2": "filetto di baccalà gadus morhua vaschetta ",
              "field3": "gr. 500 circa",
              "field4": "al kg",
              "description": "excelsior  filetto di baccalà gadus morhua vaschetta  gr. 500 circa al kg",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 74.9264585883313,
                "width": 22.814997408595396,
                "height": 37.39019068600169
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Baccala_filetto_vaschetta_gr.500_1542639464.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wDdIdCW_qULGBpc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166811",
              "field1": "fini",
              "field2": "cotechino modena igp",
              "field3": "gr. 500",
              "field4": "",
              "description": "fini cotechino modena igp gr. 500",
              "grammage": 500,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 51.38976281047218,
                "width": 23.536695777859112,
                "height": 18.540741481595322
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/G7183_New_Foto_Cotechino_gr._500_Fini_1575371419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_R0wreCu_5IRQw8t.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166823",
              "field1": "fini ",
              "field2": "zampone modena igp ",
              "field3": "kg. 1",
              "field4": "",
              "description": "fini  zampone modena igp  kg. 1",
              "grammage": null,
              "price": "10.99",
              "price_label": "€ 10,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.17721638979606,
                "left": 51.38976281047218,
                "width": 23.14165293820183,
                "height": 18.17896476075474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/G7188_New_Foto_Zampone_kg_1_Fini_1575371397.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_7lJZR2K_pWZXZ9d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239412",
              "field1": "pam",
              "field2": "i tesori ",
              "field3": "-pesce spada affumiicato gr. 100",
              "field4": "-tonno affumicato gr. 100 ",
              "description": "pam i tesori  -pesce spada affumiicato gr. 100 -tonno affumicato gr. 100 ",
              "grammage": 100,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 75.94588224046926,
                "left": 4.511345837807955,
                "width": 23.14165293820183,
                "height": 20.87174321852708
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8004263686881_T70_1606315260.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8004263686898_T70_1606315261.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_C7NZ2Dl_Xddm0BQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "177238",
              "field1": "pam",
              "field2": "pane da tramezzini",
              "field3": "gr. 250",
              "field4": "",
              "description": "pam pane da tramezzini gr. 250",
              "grammage": 250,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 58.50673194614443,
                "left": 4.511345837807955,
                "width": 26.301995655460093,
                "height": 17.439150294324822
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pam_pane_da_tramezzini_gr_250_1586857699.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_q1J1us4_XrBgO9p.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239945",
              "field1": "facino ",
              "field2": "surimi                                                            ",
              "field3": "-al sapore di gambero -al sapore di granchio",
              "field4": "gr.200",
              "description": "facino  surimi                                                             -al sapore di gambero -al sapore di granchio gr.200",
              "grammage": 200,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Gambero",
                "Granchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 79.1921664626683,
                "left": 26.238702018958506,
                "width": 24.590143350278534,
                "height": 17.439150294324822
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/surimi_al_sapore_di_gambero..._1606500576.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/surimi_al_sapore_di_granchio..._1606500576.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_F9Xxh3X_P8uXfF8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162516",
              "field1": "philadelphia",
              "field2": "classica ",
              "field3": "gr. 150",
              "field4": "",
              "description": "philadelphia classica  gr. 150",
              "grammage": 150,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 65.48347613219094,
                "left": 28.213916217244922,
                "width": 22.61492915199212,
                "height": 14.623972815744647
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PHILADELPHIA_150_1521712973_1521714151_1521824660_1521827200_1535624_kQIlRrj.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_RpHRwSM_eJKGPS0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130320",
              "field1": "philadelphia",
              "field2": "gr. 150",
              "field3": "-erbe mediterranee -salmone",
              "field4": "",
              "description": "philadelphia gr. 150 -erbe mediterranee -salmone",
              "grammage": 150,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Erbe mediterranee",
                "Salmone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 50.061199510403924,
                "left": 29.655293757649936,
                "width": 20.410546715626275,
                "height": 16.891064871481028
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/2680161_KRAFT_PHILADELPHIA_ERBE_MEDITERRANEE_GR_150_1527753374_1529594260.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/2686404_PHILADELPHIA_SALMONE_150_GR_1600067244_1600759193.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_kZT7o6l_uPtNald.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231273",
              "field1": "facino",
              "field2": "insalata di mare con verdure",
              "field3": "deliziosa",
              "field4": "kg. 1",
              "description": "facino insalata di mare con verdure deliziosa kg. 1",
              "grammage": 0,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 6.609547123623018,
                "left": 4.240871073031413,
                "width": 16.460118319053446,
                "height": 33.90452876376989
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Facino_Insalata_di_Mare_con_verdure_kg.1_1598515937.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_5RKPnop_aV3cRys.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164135",
              "field1": "baccalà ",
              "field2": "secco gadus morhua ",
              "field3": "16/20 ali bianche ",
              "field4": "imbustato al kg",
              "description": "baccalà  secco gadus morhua  16/20 ali bianche  imbustato al kg",
              "grammage": 0,
              "price": "11.90",
              "price_label": "€ 11,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 6.609547123623018,
                "left": 19.515860873113013,
                "width": 12.641370869033048,
                "height": 33.90452876376989
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3254369_Baccala_secco_1620_ali_bianche_busta_singola__1601022365.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aLIBsv7_2M0d5v6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239411",
              "field1": "La NEF  RE salmone",
              "field2": "norvegese affumumicato",
              "field3": "astuccio",
              "field4": "gr. 600",
              "description": "La NEF  RE salmone norvegese affumumicato astuccio gr. 600",
              "grammage": 600,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 15.789473684210535,
                "left": 34.65916972664219,
                "width": 24.229294165646674,
                "height": 15.055079559363527
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ReSalmone_Baffa_senza_pelle_1606490978.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_SXK0RIn_WXpkhnl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165874",
              "field1": "norita",
              "field2": "filetto salmone norvegese affumicato",
              "field3": "astuccio gr. 250",
              "field4": "",
              "description": "norita filetto salmone norvegese affumicato astuccio gr. 250",
              "grammage": 250,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 30.844553243574055,
                "left": 34.65916972664219,
                "width": 33.18359853121176,
                "height": 9.057527539779683
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Norita_filetto_di_salmone_norvegese_gr.250_1542120954.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_feBa10p_16oSJR2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139489",
              "field1": "kv nordic",
              "field2": "salmone norvegese affumicato",
              "field3": "gr. 100",
              "field4": "",
              "description": "kv nordic salmone norvegese affumicato gr. 100",
              "grammage": 100,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 13.096695226438198,
                "left": 59.67854957160343,
                "width": 14.879946960424316,
                "height": 17.747858017135865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/KV_Nordic_salmone_norvegese_affumicato_gr.100_1573482917.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_m9J7Ea5_AxYQ4mn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197318",
              "field1": "bottega del mare",
              "field2": "salmone selvaggio sockey",
              "field3": "astuccio gr. 80",
              "field4": "",
              "description": "bottega del mare salmone selvaggio sockey astuccio gr. 80",
              "grammage": 80,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 11.872705018359854,
                "left": 73.76841085271317,
                "width": 23.46628926968584,
                "height": 15.544675642594859
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Bottega_del_mare_salmone_selvaggio_affumicato_gr.80_1573482705.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TfogNx5_CRX3gxC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165872",
              "field1": "norita",
              "field2": "salmone norvegese affumicato",
              "field3": "preaffettato gr. 200",
              "field4": "",
              "description": "norita salmone norvegese affumicato preaffettato gr. 200",
              "grammage": 200,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 25.826193390452875,
                "left": 73.63672990616075,
                "width": 23.46628926968584,
                "height": 14.443084455324357
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Norita_salmone_norvegese_affumicato_gr.200_astuccio_1542120983.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_YC8Scf8_9OlNxO8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 7,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0007_uLFD0JY.jpg",
          "products": [
            {
              "item_id": "165840",
              "field1": "rocca dei forti",
              "field2": "spumante",
              "field3": "cl. 75",
              "field4": "-brut -dolce",
              "description": "rocca dei forti spumante cl. 75 -brut -dolce",
              "grammage": 750,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut",
                "Dolce"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 1.8435332517339862,
                "width": 24.124694002447978,
                "height": 36.96450428396573
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rocca_dei_Forti_spumante__Dolce_cl.75_1542027889.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rocca_dei_Forti_spumante_Brut_cl.75_1542027890.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WEfpth5_r9TL6sV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165853",
              "field1": "baileys ",
              "field2": "classico",
              "field3": "cl. 70",
              "field4": "",
              "description": "baileys  classico cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 25.968227254181958,
                "width": 19.988423092615268,
                "height": 36.96450428396573
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/baileys_70_cl_1542990091.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DxDcBTc_FTt2fqk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239415",
              "field1": "franciacorta",
              "field2": "grappa barricata",
              "field3": "cl. 50",
              "field4": "",
              "description": "franciacorta grappa barricata cl. 50",
              "grammage": 500,
              "price": "10.99",
              "price_label": "€ 10,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 45.95665034679722,
                "width": 20.832670338637286,
                "height": 36.96450428396573
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Franciacorta_grappa_barricata_cl.50_1605809620.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_HdUiF4E_Brq89Xh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133987",
              "field1": "caffo",
              "field2": "vecchio amaro del capo",
              "field3": "cl. 70",
              "field4": "",
              "description": "caffo vecchio amaro del capo cl. 70",
              "grammage": 700,
              "price": "8.79",
              "price_label": "€ 8,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 66.78932068543452,
                "width": 28.811046511627914,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Vecchio_amaro_del_capo_70_cl_1447781912_1464966848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6ISH6D7_ODqTpFM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165849",
              "field1": "vecchia romagna",
              "field2": "etichetta nera",
              "field3": "cl. 70",
              "field4": "",
              "description": "vecchia romagna etichetta nera cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 21.909424724602204,
                "left": 66.78932068543452,
                "width": 28.811046511627914,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Vecchia_Romagna_Nera_70_cl_1554221609_1574331484.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_47TMV8r_hzwDAda.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165845",
              "field1": "mumm",
              "field2": "champagne cordon rouge brut",
              "field3": "cl. 75",
              "field4": "",
              "description": "mumm champagne cordon rouge brut cl. 75",
              "grammage": 750,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 1.4484904120767033,
                "width": 18.93497552019584,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MUMM_CORDON_ROUGE_CHAMPAGNE_CL.75ASTUCCIO_1542027872.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_UiLPENZ_DpuYHiW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166817",
              "field1": "berlucchi ",
              "field2": "cuvèe imperiale franciacorta docg brut ",
              "field3": "cl. 75",
              "field4": "",
              "description": "berlucchi  cuvèe imperiale franciacorta docg brut  cl. 75",
              "grammage": 750,
              "price": "12.50",
              "price_label": "€ 12,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 20.383465932272543,
                "width": 18.725775193798448,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BERLUCCHI_BRUT_CL.75_ASTUCCIO_1605808961.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_kCdGOdt_2SYznXc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165843",
              "field1": "cinzano",
              "field2": "spumante asti docg",
              "field3": "cl. 75",
              "field4": "",
              "description": "cinzano spumante asti docg cl. 75",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 39.10924112607099,
                "width": 19.330018359853128,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Cinzano_Asti_spumante_cl.75_1542027813.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_uCBvprC_pkfqQLb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164078",
              "field1": "cinzano",
              "field2": "spumante dolce sweet edition",
              "field3": "cl. 75",
              "field4": "",
              "description": "cinzano spumante dolce sweet edition cl. 75",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 58.43925948592412,
                "width": 18.330732354141166,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CINZANO_SWEET_EDITION_SPUM.DOLCE_CL.75_1540909848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_e8p8DU6_RyhUxPV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165846",
              "field1": "sandiliano",
              "field2": "spumante grand cuvee",
              "field3": "cl. 75",
              "field4": "-brut -dessert",
              "description": "sandiliano spumante grand cuvee cl. 75 -brut -dessert",
              "grammage": 750,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut",
                "Dessert"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 76.76999184006527,
                "width": 19.46169930640555,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Sandiliano_brut_cl.75_1542027910.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Sandiliano_dessert_cl.75_1542027910.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DKm8XSd_xHfbnTT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "201327",
              "field1": "campoverde  ",
              "field2": "spumante brut",
              "field3": "metodo charmat cl. 75",
              "field4": "rosè",
              "description": "campoverde   spumante brut metodo charmat cl. 75 rosè",
              "grammage": 750,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 1.580171358629131,
                "width": 15.642951856385153,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/camporosa_1576601578.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_kRurOXp_o0Nu6ih.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131743",
              "field1": "rocca dei forti",
              "field2": "prosecco doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "rocca dei forti prosecco doc cl. 75",
              "grammage": 750,
              "price": "3.69",
              "price_label": "€ 3,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 17.223123215014283,
                "width": 15.565432476540185,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rocca_dei_Forti_Prosecco_1535462878.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_m4rxtwb_qDGLhhO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180792",
              "field1": "santa margherita",
              "field2": "prosecco extra dry doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "santa margherita prosecco extra dry doc cl. 75",
              "grammage": 750,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 32.788555691554464,
                "width": 15.774632802937582,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Prosecco_Doc_Extra_Dry_P_1558516165_1559122607.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_I8U8Htc_PEYAdqC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239414",
              "field1": "perlino",
              "field2": "fragolino rosso",
              "field3": "cl. 75",
              "field4": "",
              "description": "perlino fragolino rosso cl. 75",
              "grammage": 750,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 48.563188494492046,
                "width": 15.697113423092611,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Perlino_fragolino_cl_1605810677.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_CBt7YJG_iwen6sc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137453",
              "field1": "averna",
              "field2": "amaro",
              "field3": "cl. 70",
              "field4": "",
              "description": "averna amaro cl. 70",
              "grammage": 700,
              "price": "11.90",
              "price_label": "€ 11,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 64.26030191758467,
                "width": 15.77463280293758,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Averna_Amaro_70_cl.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_p70mWPX_JATtiyE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139599",
              "field1": "limoncè",
              "field2": "",
              "field3": "cl. 50",
              "field4": "-classico -crema",
              "description": "limoncè cl. 50 -classico -crema",
              "grammage": 500,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Crema"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 80.03493472052224,
                "width": 16.146317829457356,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Limonce_crema_cl.50_astuccio_1605810458.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/LImonce_cl.50_astuccio_1605810529.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WQq27Pn_qAPBB6W.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202050",
              "field1": "nerò",
              "field2": "liquore di liquirizia",
              "field3": "cl. 50",
              "field4": "",
              "description": "nerò liquore di liquirizia cl. 50",
              "grammage": 500,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 1.580171358629131,
                "width": 15.48791309669522,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/nero_Liquirizia_gocce_di_calabria_50_cl_1576835352.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_OzMRM9n_HWQQj52.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165852",
              "field1": "amaretto disaronno",
              "field2": "",
              "field3": "cl. 70",
              "field4": "",
              "description": "amaretto disaronno cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 17.068084455324353,
                "width": 16.1155140758874,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/0019463_Disaronno_1531469287_1574246913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TVIXioE_gkgxxQc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165851",
              "field1": "chivas regal",
              "field2": "whisky 12 years",
              "field3": "cl. 70",
              "field4": "",
              "description": "chivas regal whisky 12 years cl. 70",
              "grammage": 700,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 33.18359853121176,
                "width": 15.48791309669522,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/chivas_regal_12_years_blended_scotch_whisky_mit_etui_70cl72dpi_1574329983.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wFM8oJu_02uAAa8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139589",
              "field1": "crodino",
              "field2": "",
              "field3": "cl. 10 x 10",
              "field4": "-biondo -arancia rossa",
              "description": "crodino cl. 10 x 10 -biondo -arancia rossa",
              "grammage": 0,
              "price": "5.29",
              "price_label": "€ 5,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Biondo",
                "Arancia rossa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 48.671511627906966,
                "width": 24.54309465524277,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/54346_1509631467_1534501615.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Crodino_x_10_1495871308_1533060315_1534501635.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_D2fjErm_7vENZKW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139588",
              "field1": "campari",
              "field2": "soda\t",
              "field3": "cl. 10 x 5",
              "field4": "",
              "description": "campari soda\t cl. 10 x 5",
              "grammage": 500,
              "price": "4.90",
              "price_label": "€ 4,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 73.21460628314975,
                "width": 22.59868421052631,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Campari_soda_cl.10x5_1605809043.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_QmqTiIE_s6xsyXg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 8,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0008_uVCIsH6.jpg",
          "products": [
            {
              "item_id": "130313",
              "field1": "corvo di salaparuta ",
              "field2": "vino igt",
              "field3": "cl. 75",
              "field4": "-rosso -rosato -bianco sicilia",
              "description": "corvo di salaparuta  vino igt cl. 75 -rosso -rosato -bianco sicilia",
              "grammage": 750,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Rosso",
                "Rosato",
                "Bianco di sicilia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 11.138310893512852,
                "left": 4.213790289677683,
                "width": 15.619594043247647,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CORVO_Bianco_cl.75_1584123041.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CORVO_Rosato_cl.75_1584123042.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CORVO_Rosso_cl.75_1584123043.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0CkiLIq_7zoDc7T.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232179",
              "field1": "caparra e siciliani ",
              "field2": "cirò",
              "field3": "cl.75",
              "field4": "-rosso -bianco -rosato",
              "description": "caparra e siciliani  cirò cl.75 -rosso -bianco -rosato",
              "grammage": 750,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Rosso",
                "Bianco",
                "Rosato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 11.138310893512852,
                "left": 35.8172174622603,
                "width": 14.961189310485508,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ciro_caparra_dei_siciliani_bianco_1519234959_1599815054_m3w3D8I.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ciro_caparra_di_siciliani_rosato_1519234960_1599815054_0agi3Ru.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ciro_caparra_di_siciliani_rosso_classico_1519234961_1599815054_j6QMcMB.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_AmYjoY5_JZqlliN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239947",
              "field1": "caparra                                                      ",
              "field2": "confezione 3 bottiglie vino ciro' doc",
              "field3": "cl.75",
              "field4": "",
              "description": "caparra                                                       confezione 3 bottiglie vino ciro' doc cl.75",
              "grammage": 750,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 11.138310893512852,
                "left": 20.228427172582613,
                "width": 15.588790289677691,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/confezione_da_tre_bottiglie_1606500631.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0rrjG8o_aAxMbPP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239419",
              "field1": "parmigiano reggiano dop",
              "field2": "vacche rosse ",
              "field3": "stagionato oltre 24 mesi",
              "field4": "l'etto",
              "description": "parmigiano reggiano dop vacche rosse  stagionato oltre 24 mesi l'etto",
              "grammage": 100,
              "price": "2.19",
              "price_label": "€ 2,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 11.015911872705017,
                "left": 52.04105467156263,
                "width": 24.887698898408814,
                "height": 30.477356181150547
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606141928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VACCHE_ROSSE_Formaggio_1606754353.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TJsUSPs_oxNsZKe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165818",
              "field1": "san martino terrantica di puglia",
              "field2": "valigetta 3 vini da cl. 75",
              "field3": "",
              "field4": "",
              "description": "san martino terrantica di puglia valigetta 3 vini da cl. 75",
              "grammage": null,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 4.345471236230111,
                "width": 15.143308853529174,
                "height": 19.583843329253366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/San_Martino_Valigetta_x3_TerrAntica_Prim-Loc-Negr_1573489538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_1t4Cjf1_NE6uJpv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": " -primitivo igp salento, -locorotondo dop, -negroamaro igp salento",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/F5jaVecXHK/images/San_Martino_Valigetta_x3_TerrAntica_Prim-Loc-Negr_1573489538.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239948",
              "field1": "malena                                                              ",
              "field2": "confezione 3 bottiglie di vino ciro' doc",
              "field3": "cl.75",
              "field4": "",
              "description": "malena                                                               confezione 3 bottiglie di vino ciro' doc cl.75",
              "grammage": 750,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 19.488780089759285,
                "width": 15.538351693186454,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VALIGETTA_X_3_BTG_CIRO_1606500653.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Z6bcpCZ_rpXkL7r.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "235048",
              "field1": "senatore                                                            ",
              "field2": "puntalice cirò rosato dop ",
              "field3": "cl.75",
              "field4": "",
              "description": "senatore                                                             puntalice cirò rosato dop  cl.75",
              "grammage": 750,
              "price": "6.49",
              "price_label": "€ 6,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 35.02713178294574,
                "width": 15.670032639738883,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/senatore_puntalice_1511459582_1562317919_1602774583.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0GvJBzt_HQf26FS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140780",
              "field1": "soloperto",
              "field2": "primitivo manduria riserva doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "soloperto primitivo manduria riserva doc cl. 75",
              "grammage": 750,
              "price": "6.49",
              "price_label": "€ 6,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 35.02713178294574,
                "width": 15.670032639738883,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/soloperto_primitivo_di_manuria_1537354107.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_b4Ao8ur_IvgBmZB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197363",
              "field1": "santa margherita",
              "field2": "gewurztraminer doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "santa margherita gewurztraminer doc cl. 75",
              "grammage": 750,
              "price": "6.99",
              "price_label": "€ 6,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 35.02713178294574,
                "width": 15.670032639738883,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/59778_Santa_Margherita_gewurztraminer_75_cl_1573484611.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Dm5WqnO_OQ4yySl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "233744",
              "field1": "val di neto",
              "field2": "vino igt calabria ",
              "field3": "cl. 75",
              "field4": "-amistà rosato -kalipso bianco -neaithos rosso",
              "description": "val di neto vino igt calabria  cl. 75 -amistà rosato -kalipso bianco -neaithos rosso",
              "grammage": 750,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Amistà rosato",
                "Kalipso bianco",
                "Neaithos rosso"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 19.883822929416564,
                "width": 15.14330885352917,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Val_di_Neto_Neaithos_1601651465.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Val_di_Neto_Kalypso_1601651465.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Val_di_Neto_Amisto_1601651466.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_f56Wm33_NSTsxVZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239950",
              "field1": "senatore                                         ",
              "field2": "ehos calabria rosso igp ",
              "field3": "cl.75",
              "field4": "",
              "description": "senatore                                          ehos calabria rosso igp  cl.75",
              "grammage": 750,
              "price": "7.90",
              "price_label": "€ 7,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 4.213790289677683,
                "width": 15.670032639738883,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Ehos_Calabria_rosso_cl.75_1606813969.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Be9Wmcu_ze0pxFo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231336",
              "field1": "apocc",
              "field2": "formaggio canestrato stagionato",
              "field3": "l'etto",
              "field4": "",
              "description": "apocc formaggio canestrato stagionato l'etto",
              "grammage": 100,
              "price": "1.19",
              "price_label": "€ 1,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.70257037943698,
                "left": 51.618931048551616,
                "width": 18.56701346389229,
                "height": 17.503059975520195
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/APOCC_formaggio_Canestrato_Stagionato_1598515195.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ECgTpij_y6KOjSw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "233612",
              "field1": "apocc",
              "field2": "ricotta pecorina dura affumicata gr.250 circa ",
              "field3": "l'etto",
              "field4": "",
              "description": "apocc ricotta pecorina dura affumicata gr.250 circa  l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.70257037943698,
                "left": 70.18594451244391,
                "width": 27.91636066911465,
                "height": 17.503059975520195
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/RICOTTA_AFFUMICATA_1602226031.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_xIE6l0p_jmxsFmf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "172734",
              "field1": "auricchio",
              "field2": "provolone stravecchio",
              "field3": "l'etto",
              "field4": "",
              "description": "auricchio provolone stravecchio l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 75.32150142798858,
                "width": 22.780803753569973,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/auricchio_stravecchio_mandarone_1483356738_1511371570_1533221200.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_E15HKgs_0iUVEMn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139406",
              "field1": "busti",
              "field2": "le delizie pecorino fresco",
              "field3": "l'etto",
              "field4": "-mandorle -pistacchi bronte dop",
              "description": "busti le delizie pecorino fresco l'etto -mandorle -pistacchi bronte dop",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Mandorle",
                "Pistacchi bronte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 51.35556915544676,
                "width": 23.965932272541817,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BUSTI__Mandorlo_di_Pura_Pecora_1_1535990621_1544437788.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Busti_pecorino__Il_Pistacchio_1535990621_1544437812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606142205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_tPOaw2y_wJFlqxK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131534",
              "field1": "emmentaler",
              "field2": "switzerland dop",
              "field3": "l'etto",
              "field4": "",
              "description": "emmentaler switzerland dop l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 41.86046511627907,
                "left": 51.35556915544676,
                "width": 23.965932272541817,
                "height": 17.38066095471236
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/EMMENTALER_1562605027.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606142147.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iYvN11a_wyYobVd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216519",
              "field1": "casearia crotonese ",
              "field2": "pecorino fresco",
              "field3": "l'etto",
              "field4": "-alla nduja",
              "description": "casearia crotonese  pecorino fresco l'etto -alla nduja",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 41.86046511627907,
                "left": 75.32150142798858,
                "width": 23.307527539779684,
                "height": 17.38066095471236
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/caseariacrotonese-nduja_1602346322.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Eq23G4e_RhrBfgX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino di puglia igt",
              "field3": "cl. 75",
              "field4": "-bianco -rosato",
              "description": "donna marzia vino di puglia igt cl. 75 -bianco -rosato",
              "grammage": 750,
              "price": "2.89",
              "price_label": "€ 2,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianco",
                "Rosato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.31313386053718,
                "left": 4.082109343125255,
                "width": 15.515095879232964,
                "height": 18.58303460450705
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DONNA_MARZIA_BIANCO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DONNA_MARZIA_ROSATO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9TPartB_VHqJcvn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino rosso di puglia igt",
              "field3": "cl. 75",
              "field4": "",
              "description": "donna marzia vino rosso di puglia igt cl. 75",
              "grammage": 750,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.31313386053718,
                "left": 19.597205222358216,
                "width": 15.166564667482666,
                "height": 18.58303460450705
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DONNA_MARZIA_ROSSO_cl.75_1533303702_1606328544.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_qYYzaMu_d3fOp6D.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 9,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0009_2klwWtM.jpg",
          "products": [
            {
              "item_id": "130161",
              "field1": "asiago",
              "field2": "fresco dop",
              "field3": "l'etto",
              "field4": "",
              "description": "asiago fresco dop l'etto",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 11.383108935128519,
                "left": 1.7118523051815586,
                "width": 46.74673602611179,
                "height": 23.623011015911874
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/asiago_fresco_1535464821_1603265396.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/asiago_fresco_dop_1603354834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606141963.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_XRgcOwF_ZF9U7uY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232178",
              "field1": "la brugnano",
              "field2": "provola vaccina fresca sottovuoto",
              "field3": "",
              "field4": "",
              "description": "la brugnano provola vaccina fresca sottovuoto",
              "grammage": 100,
              "price": "3.99",
              "price_label": "€ 3,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 35.618115055079556,
                "left": 1.8435332517339862,
                "width": 24.756017951856386,
                "height": 23.623011015911874
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/fette_provolone_generiche_1600445426.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PROVOLA_LA_BRUGNANO_1600445427.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WNfqlRr_EoVjRPJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "235041",
              "field1": "facino  ",
              "field2": "insalata ",
              "field3": "-russa -capricciosa",
              "field4": "l'etto",
              "description": "facino   insalata  -russa -capricciosa l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Russa",
                "Capricciosa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Piatti Pronti",
              "blueprint": {
                "top": 35.618115055079556,
                "left": 26.599551203590377,
                "width": 21.72735618115055,
                "height": 23.623011015911874
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Insalata_Russa_ciotola_1544539037_1602774432.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Ya6oDvy_FjLWdqJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132599",
              "field1": "auricchio",
              "field2": "dolce ",
              "field3": "-provoletta -salamino",
              "field4": "l'etto",
              "description": "auricchio dolce  -provoletta -salamino l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Provoletta",
                "Salamino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 48.6173500611995,
                "width": 23.702570379436963,
                "height": 17.8702570379437
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/auricchio_provolette_1606487163.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_suWYGIC_z12XwK5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131544",
              "field1": "leonardi",
              "field2": "gran riserva gorgonzola dolce dop al cucchiaio",
              "field3": "l'etto",
              "field4": "",
              "description": "leonardi gran riserva gorgonzola dolce dop al cucchiaio l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 72.31992044063648,
                "width": 24.624337005303964,
                "height": 17.8702570379437
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/fetta_gorgonzola_Santi_1446631679_1519141915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/leonardi_gran_riserva_1602225683.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606142282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Sa6FxWp_EJeWrXB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239422",
              "field1": "mauri",
              "field2": "fioroni di capra alle erbe",
              "field3": "gr. 90 circa",
              "field4": "l'etto",
              "description": "mauri fioroni di capra alle erbe gr. 90 circa l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.41982864137087,
                "left": 72.31992044063648,
                "width": 24.624337005303964,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/266_1606295846.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_woII661_3qqBtnp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239421",
              "field1": "torta",
              "field2": "gorgonzola&mascarpone con noci",
              "field3": "l'etto",
              "field4": "",
              "description": "torta gorgonzola&mascarpone con noci l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Piatti Pronti",
              "blueprint": {
                "top": 21.41982864137087,
                "left": 48.88071195430437,
                "width": 23.439208486332106,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/torta_gorgonzolamascarpone_con_noci_1606295928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_tbCA5rl_XvYSv8G.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131553",
              "field1": "nonno nanni",
              "field2": "stracchino classico",
              "field3": "gr. 200 circa",
              "field4": "l'etto",
              "description": "nonno nanni stracchino classico gr. 200 circa l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 48.88071195430437,
                "width": 23.439208486332106,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Stracchino_Nonno_Nanni_200g_1582284555_1592228248.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/impiattato_stracchino-bio-781x521_1592577414.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_koBaOhB_MiQwrUN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "173545",
              "field1": "burrata di andria",
              "field2": "igp",
              "field3": "in foglia",
              "field4": "gr. 350 circa l'etto",
              "description": "burrata di andria igp in foglia gr. 350 circa l'etto",
              "grammage": 100,
              "price": "0.89",
              "price_label": "€ 0,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 72.31992044063648,
                "width": 23.702570379436967,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/burrata_in_piatto_1530889237_1551522973.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/burrata_di_andria_igp_1551720906.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_IGP_1606142325.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_2zivCkN_IbcqzO6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239417",
              "field1": "king's",
              "field2": "rebello culatta stagionata",
              "field3": "l'etto",
              "field4": "",
              "description": "king's rebello culatta stagionata l'etto",
              "grammage": 100,
              "price": "2.89",
              "price_label": "€ 2,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 76.92875356997143,
                "width": 19.093737250102002,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/kings_rebello_culatello_1480434115_1605714926.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/snocciolato_crudo_Piatto_1480434116_1605714927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_YYEciHP_57oLRcS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231045",
              "field1": "dedoni",
              "field2": "mozzarella artgianale",
              "field3": "l'etto",
              "field4": "",
              "description": "dedoni mozzarella artgianale l'etto",
              "grammage": 100,
              "price": "0.89",
              "price_label": "€ 0,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.73072215422276,
                "left": 57.43997348021216,
                "width": 19.488780089759278,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mozzarellE_FIORDILATTE_1490979430_1562692156_1564388574_1576834395_1_YuRs9OI.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Jc3K3Sl_82KxEDD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239940",
              "field1": "dedoni                                               ",
              "field2": "ricotta vaccina fresca",
              "field3": "l'etto",
              "field4": "",
              "description": "dedoni                                                ricotta vaccina fresca l'etto",
              "grammage": 100,
              "price": "4.90",
              "price_label": "€ 4,90 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.73072215422276,
                "left": 38.609598123215015,
                "width": 18.83037535699715,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ricotta_fresca_pomodorini_shutter_1476191184_1521474329_1524729360_1_6pyZuIA.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_q6TQ4WQ_3pQNcJO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231044",
              "field1": "dedoni",
              "field2": "pecorino semistagionato",
              "field3": "l'etto",
              "field4": "",
              "description": "dedoni pecorino semistagionato l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.73072215422276,
                "left": 20.56930844553243,
                "width": 18.040289677682576,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/62065_DedoniCassiodoreoPecorino_1568729870_1597139155_1597850368.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iRT8CGB_p3egoRE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165866",
              "field1": "biffi",
              "field2": "salsa per formaggi",
              "field3": "gr. 100",
              "field4": "-di fichi -di pere",
              "description": "biffi salsa per formaggi gr. 100 -di fichi -di pere",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Di fichi",
                "Di pere"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.73072215422276,
                "left": 1.870614035087713,
                "width": 18.171970624235012,
                "height": 36.96450428396573
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BIFFI_SALSA_G100_FICHI_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BIFFI_SALSA_G100_PERE_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dZUoyt7_EJR6xjC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231048",
              "field1": "bufà",
              "field2": "treccia di latte di bufala",
              "field3": "l'etto",
              "field4": "",
              "description": "bufà treccia di latte di bufala l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.58017135862913,
                "left": 20.305946552427578,
                "width": 17.776927784577726,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/treccione_di_bufala_1469120843_1534931523_1546622972_1561136415_1563_yy72WQd.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vuCS0wS_eEziAqt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206123",
              "field1": "bufà",
              "field2": "ciliegine alla panna di latte di bufala",
              "field3": "gr. 150",
              "field4": "",
              "description": "bufà ciliegine alla panna di latte di bufala gr. 150",
              "grammage": 150,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.58017135862913,
                "left": 38.08287433700531,
                "width": 19.75214198286414,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CILIEGINEPANNA_1561395247_1581938153.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/vaschetta_250g_1582190996.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9Zgrr4W_eeGtXRB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130143",
              "field1": "veroni",
              "field2": "prosciutto affumicato",
              "field3": "l'appetitoso",
              "field4": "l'etto",
              "description": "veroni prosciutto affumicato l'appetitoso l'etto",
              "grammage": 100,
              "price": "1.69",
              "price_label": "€ 1,69 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.58017135862913,
                "left": 57.83501631986944,
                "width": 19.093737250102002,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VERONI_PROSCIUTTO_AFFUMICATO_LAPPETITOSO_1530541540_1535385252.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/piatto_prosciutto_cotto_1588066373.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ZJQ2ZOb_qkd05uK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132573",
              "field1": "negroni",
              "field2": "petto di tacchino arrosto ",
              "field3": "l'etto",
              "field4": "",
              "description": "negroni petto di tacchino arrosto  l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.58017135862913,
                "left": 76.92875356997143,
                "width": 19.093737250102002,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/negroni_Petto_Di_Tacchino__1535450295.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vSenZM9_0vmZULd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 10,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0010_lBEgBm3.jpg",
          "products": [
            {
              "item_id": "132579",
              "field1": "king's",
              "field2": "prosciutto san daniele dop",
              "field3": "l'etto",
              "field4": "",
              "description": "king's prosciutto san daniele dop l'etto",
              "grammage": 100,
              "price": "2.49",
              "price_label": "€ 2,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 11.627906976744185,
                "left": 4.109190126478985,
                "width": 37.00234598123215,
                "height": 23.623011015911874
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/prosciutto_crudo_san_daniele_con_osso_1443790141_1544181461_1561023761.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_DOP_1606141765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6MCu8HP_ePoUFUm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130115",
              "field1": "palmieri",
              "field2": "mortadella favola in cotenna",
              "field3": "l'etto",
              "field4": "",
              "description": "palmieri mortadella favola in cotenna l'etto",
              "grammage": 100,
              "price": "1.19",
              "price_label": "€ 1,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 35.618115055079556,
                "left": 4.109190126478985,
                "width": 37.00234598123215,
                "height": 23.623011015911874
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Palmieri_mortadella_Favola_cotenna_1495124184_1529687251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/piatto_mortadella_pam_1535464739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_1RtCZ48_oWK3RtF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134689",
              "field1": "coati ",
              "field2": "prealpen speck",
              "field3": "l'etto",
              "field4": "",
              "description": "coati  prealpen speck l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 41.506578947368425,
                "width": 19.093737250102002,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Speck_piatto_1511363327.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/coati_PrealpenSpeck_1542641430_1575455895.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_pVESFG6_qdtB1Wg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134690",
              "field1": "lazzeri",
              "field2": "bresaola ",
              "field3": "punta d’anca igp",
              "field4": "l'etto",
              "description": "lazzeri bresaola  punta d’anca igp l'etto",
              "grammage": 100,
              "price": "2.49",
              "price_label": "€ 2,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 60.60031619747042,
                "width": 18.303651570787437,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/LAZZERI_BRESAOLA_IGP__1532682073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/bresaola_carpaccio_1523452035_1529687991_1551522451_1562594337_1590484299.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_IGP_1606141854.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ljrYTEx_RvY12i8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185334",
              "field1": "wuber",
              "field2": "grande abbuffata",
              "field3": "l'etto",
              "field4": "",
              "description": "wuber grande abbuffata l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 79.29901060791514,
                "width": 19.488780089759285,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/wuber_grande_abbuffata_pasticcio_gastronomica_1483357975_1563525153.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Wuber_Grande_Abbuffata_Pasticcio_Gastronomico_Meta_1436178410_155111_LeT0Urm.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_KB8im8A_QptXWGu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140755",
              "field1": "levoni",
              "field2": "salame milano",
              "field3": "l'etto",
              "field4": "",
              "description": "levoni salame milano l'etto",
              "grammage": 100,
              "price": "1.99",
              "price_label": "€ 1,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 79.29901060791514,
                "width": 19.488780089759285,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/2416760000000_T70_1606321276.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Fette_Salame_1606321278.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_zYaBvVw_30VPP7n.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185459",
              "field1": "salumificio caputo",
              "field2": "nduja piccante di suino nero",
              "field3": "gr. 300",
              "field4": "",
              "description": "salumificio caputo nduja piccante di suino nero gr. 300",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 60.73199714402285,
                "width": 18.56701346389229,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/caputo_locandina_1598516937.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Caputo-nduja-piccante_1598516958.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6v2hL3P_hrP8ELy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185456",
              "field1": "salumificio caputo",
              "field2": "salsiccia di suino nero",
              "field3": "-dolce bianca -dolce rossa -piccante rossa",
              "field4": "gr. 300 circa - l'etto",
              "description": "salumificio caputo salsiccia di suino nero -dolce bianca -dolce rossa -piccante rossa gr. 300 circa - l'etto",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 41.901621787025704,
                "width": 18.830375356997145,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Caputo-Salsiccia-di-suino-nero_1598516982.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gsJAL3x_3PX8dn5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239418",
              "field1": "clai",
              "field2": "salame nobile italiano",
              "field3": "l'etto",
              "field4": "",
              "description": "clai salame nobile italiano l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.7796817625459,
                "left": 41.901621787025704,
                "width": 18.303651570787437,
                "height": 19.583843329253366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Salame_Nobile_1606381151.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_7OXxFjy_vjKaq0E.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130093",
              "field1": "golfera",
              "field2": "salame di prosciutto golfetta",
              "field3": "l'etto",
              "field4": "",
              "description": "golfera salame di prosciutto golfetta l'etto",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.7796817625459,
                "left": 60.20527335781313,
                "width": 19.093737250102002,
                "height": 19.583843329253366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GOLFETTA_BT_interometa_1600348825.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6H7gF5j_EaauAUG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197454",
              "field1": "san vincenzo",
              "field2": "-soppressata •dolce •piccante",
              "field3": "-spianata piccante",
              "field4": " l'etto",
              "description": "san vincenzo -soppressata •dolce •piccante -spianata piccante  l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Dolce",
                "Piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.7796817625459,
                "left": 79.29901060791514,
                "width": 20.70098939208486,
                "height": 19.583843329253366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/SAN_VINCENZO_Spianata_pic_1606321185.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/2316620000000_T1_1606321672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_yiaB7Mc_5L4G0MW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232952",
              "field1": "bisanzio ",
              "field2": "pancetta arrotolata magretta oro ",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio  pancetta arrotolata magretta oro  l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 79.29901060791514,
                "width": 19.384179926560584,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Pancetta_magretta_1600764170.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_PHMKsBk_hBSBd1J.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130240",
              "field1": "capocollo",
              "field2": "di martina franca",
              "field3": "l'etto",
              "field4": "",
              "description": "capocollo di martina franca l'etto",
              "grammage": 100,
              "price": "2.19",
              "price_label": "€ 2,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 60.627396980824145,
                "width": 18.671613627090984,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Capocollo_di_Martina_Franca_RE_DELLA_VALLE_1605784618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_QLNqJKv_Py8DHeZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134688",
              "field1": "levoni ",
              "field2": "salsiccia napoli ",
              "field3": "gr. 400 circa l'etto",
              "field4": "-dolce -forte",
              "description": "levoni  salsiccia napoli  gr. 400 circa l'etto -dolce -forte",
              "grammage": 100,
              "price": "1.79",
              "price_label": "€ 1,79 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Dolce",
                "Forte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 42.03330273357813,
                "width": 18.59409424724602,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/levoni_salsiccia_napoli_dolce_1535389765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_KnsjjMh_Bh6oPbo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165857",
              "field1": "veroni",
              "field2": "salame felino igp",
              "field3": "l'etto",
              "field4": "",
              "description": "veroni salame felino igp l'etto",
              "grammage": 100,
              "price": "2.29",
              "price_label": "€ 2,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 3.8729090167278613,
                "width": 38.160393716850265,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Veroni_Felino_1542120806.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/salame_felino_tagliere_1430238144_1565187589_1574691880.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Logo_IGP_1606141817.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_eBwjHZj_kkyh4pp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216394",
              "field1": "bisanzio",
              "field2": "guanciale al pepe",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio guanciale al pepe l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.33537331701346,
                "left": 4.399632802937572,
                "width": 18.013208894328848,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Guanciale_ambientato_1488206147_1522318641_1594138585.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iQHMrZx_Apl0AG2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239416",
              "field1": "medusa",
              "field2": "frittura marinata vaschetta",
              "field3": "gr. 150",
              "field4": "",
              "description": "medusa frittura marinata vaschetta gr. 150",
              "grammage": 150,
              "price": "2.29",
              "price_label": "€ 2,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 78.33537331701346,
                "left": 22.41284169726642,
                "width": 19.25249898000816,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/23TA_Frittura_1605893592.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_1X3W71L_O5kUgZZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239941",
              "field1": "buscema ",
              "field2": "olive nere ",
              "field3": "-alla monacale -secche",
              "field4": "l'etto",
              "description": "buscema  olive nere  -alla monacale -secche l'etto",
              "grammage": 100,
              "price": "0.49",
              "price_label": "€ 0,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Alla monacale",
                "Secche"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.33537331701346,
                "left": 41.66534067727457,
                "width": 18.671613627090984,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NERE_MONACALE_Tavola_disegno_1_1606500398.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NERE_SECCHE_Tavola_disegno_1_1606500399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_D12s56M_uF525bt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239943",
              "field1": "de roberto   ",
              "field2": "pesciolini pepati ",
              "field3": "-dolci -piccanti",
              "field4": "l'etto",
              "description": "de roberto    pesciolini pepati  -dolci -piccanti l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Dolci",
                "Piccanti"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.33537331701346,
                "left": 60.33695430436557,
                "width": 18.989137086903302,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/De_roberto_pesiolini_pepati_1606725744.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ww9fYOj_K64nMb7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "204467",
              "field1": "parigini ",
              "field2": "pane precotto",
              "field3": "al kg",
              "field4": "",
              "description": "parigini  pane precotto al kg",
              "grammage": 0,
              "price": "2.49",
              "price_label": "€ 2,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Panetteria",
              "blueprint": {
                "top": 78.33537331701346,
                "left": 79.32609139126886,
                "width": 18.698694410444716,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Sfilatino_1580987208.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_o3TQTKn_4JKg4o9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 11,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0011_AlDjSD3.jpg",
          "products": [
            {
              "item_id": "141466",
              "field1": "finocchio",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "finocchio al kg",
              "grammage": 0,
              "price": "0.99",
              "price_label": "€ 0,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 11.505507955936354,
                "left": 1.5026519787841643,
                "width": 47.010097919216655,
                "height": 23.990208078335375
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/finocchio_DOK_1427206958_1588756920.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_z3ogdh6_QdVL4iS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "189921",
              "field1": "mele golden",
              "field2": "",
              "field3": "al kg",
              "field4": "",
              "description": "mele golden al kg",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 35.49571603427173,
                "left": 1.5026519787841643,
                "width": 47.010097919216655,
                "height": 23.86780905752754
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mela_golden_1536942795_1568626510.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_oNE61HZ_Rt6o4DT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132337",
              "field1": "melone",
              "field2": "giallo",
              "field3": "al kg",
              "field4": "",
              "description": "melone giallo al kg",
              "grammage": 0,
              "price": "1.39",
              "price_label": "€ 1,39 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 48.64443084455324,
                "width": 23.439208486332117,
                "height": 18.482252141982862
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Melone_di_pane_giallo_1428426467_1471603674_1535387058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_L7VXcGo_RjSazll.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131267",
              "field1": "uva  ",
              "field2": "red globe",
              "field3": "al kg",
              "field4": "",
              "description": "uva   red globe al kg",
              "grammage": 0,
              "price": "2.29",
              "price_label": "€ 2,29 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 3.6719706242350063,
                "left": 72.18823949408404,
                "width": 23.439208486332113,
                "height": 17.625458996328028
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/uva_red_globe_1471350509_1471603655_1505125375_1606124996.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JGMbob3_xXFEzcb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170390",
              "field1": "arance tarocco",
              "field2": "confezione",
              "field3": "",
              "field4": "",
              "description": "arance tarocco confezione",
              "grammage": 1500,
              "price": "2.38",
              "price_label": "€ 2,38",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 21.297429620563037,
                "left": 72.18823949408404,
                "width": 23.439208486332113,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/arance_navel_tarocco_1487256171_1487687804_1545929892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/arance_tarocco_rete_1546859632.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8k4SGJI_iq5NUt8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239908",
              "field1": "cipolla",
              "field2": "rossa confezione",
              "field3": "gr. 750",
              "field4": "",
              "description": "cipolla rossa confezione gr. 750",
              "grammage": 750,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 72.18823949408404,
                "width": 23.439208486332113,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cipolla_rossa_1606328126.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TCyU09j_vgDWz1A.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202821",
              "field1": "pomodoro ciliegino",
              "field2": "gr. 500",
              "field3": "",
              "field4": "",
              "description": "pomodoro ciliegino gr. 500",
              "grammage": 500,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 48.74903100775194,
                "width": 23.439208486332113,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pomodori_ciliegino_vaschetta_carrefour_1428569690_1453884677_1503578_3CpnaG2.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_xckncEz_7KqtMR2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "219014",
              "field1": "funghi champignons",
              "field2": "affettato",
              "field3": "vaschetta",
              "field4": "gr. 300",
              "description": "funghi champignons affettato vaschetta gr. 300",
              "grammage": 300,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 1.475571195430434,
                "width": 23.439208486332113,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Funghi_Champignon_Tagliati_vaschetta_1453298241_1573035750_1596807737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_C8ESYw8_gKrAKUe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185294",
              "field1": "pam",
              "field2": "insalata mista",
              "field3": "formato convenienza busta gr. 400",
              "field4": "",
              "description": "pam insalata mista formato convenienza busta gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 25.70486536107711,
                "width": 22.780803753569973,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260766_PAM_INSALATA_MISTA_MAXI_GR.400_1594732248.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_y0t3dcT_VCKCTHT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137268",
              "field1": "bonduelle",
              "field2": "insalata iceberg",
              "field3": "gr. 200",
              "field4": "",
              "description": "bonduelle insalata iceberg gr. 200",
              "grammage": 200,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 25.70486536107711,
                "width": 22.780803753569973,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/insalata_iceberg_piatto_1535385523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8006862005360_T5_1606404667.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_IdLGfUk_4LDNVAc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "184541",
              "field1": "pam",
              "field2": "insalata valeriana",
              "field3": "busta gr. 200",
              "field4": "",
              "description": "pam insalata valeriana busta gr. 200",
              "grammage": 200,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 1.738933088535293,
                "width": 23.307527539779677,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8004263520031_T5_1600339087.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aJsd9Ew_dkLIgSF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239909",
              "field1": "datteri",
              "field2": "kenta",
              "field3": "gr. 200",
              "field4": "",
              "description": "datteri kenta gr. 200",
              "grammage": 200,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 67.80905752753978,
                "left": 48.74903100775194,
                "width": 14.879946960424313,
                "height": 28.886168910648713
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4077_DATTERI_KENTA_BF_25X200G_GOND_6194001160215_1606294058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_KGEsivS_nh60yDy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231268",
              "field1": "pam",
              "field2": "uva sultanina",
              "field3": "busta",
              "field4": "gr. 250",
              "description": "pam uva sultanina busta gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 67.80905752753978,
                "left": 63.62897796817626,
                "width": 16.065075479396167,
                "height": 28.886168910648713
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8004263669853_1598953242.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ikYPwtO_qpgmDFM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239910",
              "field1": "misto frutta secca",
              "field2": "gr. 400",
              "field3": "",
              "field4": "",
              "description": "misto frutta secca gr. 400",
              "grammage": 400,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 67.80905752753978,
                "left": 79.69405344757241,
                "width": 16.06507547939616,
                "height": 28.886168910648713
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Misto_frutta_secca_gr._400_2_1606294025.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ClSnkAf_glckULD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131266",
              "field1": "ananas",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "ananas al kg",
              "grammage": 0,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 21.614235451724447,
                "left": 48.69869441044471,
                "width": 24.12086903304774,
                "height": 18.58303460450705
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ananas_singola_pam_1539676692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ananas_aperta_shutter_1574095197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sgQ76dG_QgHFZUc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 12,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0012_ZSO6iIi.jpg",
          "products": [
            {
              "item_id": "133969",
              "field1": "rana",
              "field2": "rustici pasta ripiena",
              "field3": "gr. 250",
              "field4": "",
              "description": "rana rustici pasta ripiena gr. 250",
              "grammage": 250,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cappelletti al prosciutto crudo",
                "Tortellini alla carne",
                "Tortelloni ricotta e spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 3.254382330549415,
                "left": 4.318339453284375,
                "width": 52.649122807017534,
                "height": 55.91473595089628
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3._Rustici_Crudo4_1584706231_1588922623.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3d-rustici-carne_1581408839_1588922701.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8JgHV8f_RJvTudD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165888",
              "field1": "aia",
              "field2": "cappone tradizionale di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia cappone tradizionale di natale al kg",
              "grammage": 0,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 3.254382330549415,
                "left": 57.75754793961648,
                "width": 20.170440636474922,
                "height": 19.07263068773838
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cappone_1543315853.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6cZH4fr_suDTt22.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165891",
              "field1": "aia",
              "field2": "tacchinella leggera di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia tacchinella leggera di natale al kg",
              "grammage": 0,
              "price": "6.90",
              "price_label": "€ 6,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 3.254382330549415,
                "left": 77.9279885760914,
                "width": 20.123929008567917,
                "height": 19.07263068773838
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/tacchinella_1543316183.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9bLI4LY_dlru61a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165890",
              "field1": "aia",
              "field2": "pollo eviscerato tradizionale di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia pollo eviscerato tradizionale di natale al kg",
              "grammage": 0,
              "price": "3.50",
              "price_label": "€ 3,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 22.327013018287793,
                "left": 77.9279885760914,
                "width": 20.123929008567917,
                "height": 18.381469679458682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/eviscerato_1543316099.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jhnRbiF_ADfl19U.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165889",
              "field1": "aia",
              "field2": "faraona",
              "field3": "al kg",
              "field4": "",
              "description": "aia faraona al kg",
              "grammage": 0,
              "price": "5.50",
              "price_label": "€ 5,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 22.327013018287793,
                "left": 57.3625050999592,
                "width": 20.565483476132208,
                "height": 18.381469679458682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/faraona_1543315930.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_qpxfFKo_yByBsSR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137275",
              "field1": "bovino",
              "field2": "pancia con osso",
              "field3": "al kg",
              "field4": "",
              "description": "bovino pancia con osso al kg",
              "grammage": 0,
              "price": "5.90",
              "price_label": "€ 5,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 40.70848269774648,
                "left": 57.3625050999592,
                "width": 20.565483476132208,
                "height": 18.46063558369921
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pancia_con_osso_PAM_1590685052.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_fezDkuY_A7F2TDz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239425",
              "field1": "odori ",
              "field2": "per brodo e bollitto",
              "field3": "gr. 500",
              "field4": "",
              "description": "odori  per brodo e bollitto gr. 500",
              "grammage": 500,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 40.70848269774648,
                "left": 77.9279885760914,
                "width": 20.255609955120345,
                "height": 18.46063558369921
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/odori_1606320620.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_AKzXBiI_o9ryKSi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133884",
              "field1": "bovino",
              "field2": "macinato scelto",
              "field3": "al kg",
              "field4": "",
              "description": "bovino macinato scelto al kg",
              "grammage": 0,
              "price": "6.90",
              "price_label": "€ 6,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 59.169118281445684,
                "left": 66.99847001223989,
                "width": 31.185128518971833,
                "height": 18.381469679458682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Macinato_di_Bovino_Adulto_Cliente_1_1535450999.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_s4HRTEu_v9RZZnu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239944",
              "field1": "salsiccia calabra ",
              "field2": "di suino",
              "field3": "",
              "field4": "al kg",
              "description": "salsiccia calabra  di suino al kg",
              "grammage": null,
              "price": "5.90",
              "price_label": "€ 5,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [
                "Dolce",
                "Piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 59.169118281445684,
                "left": 35.5034679722562,
                "width": 31.495002039983703,
                "height": 18.381469679458682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/salsiccia_calabra__di_suino_dolce_1606809092.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_1HGxNsQ_pE2pQ1H.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134728",
              "field1": "bovino",
              "field2": "fettine scelte",
              "field3": "al kg",
              "field4": "",
              "description": "bovino fettine scelte al kg",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 59.169118281445684,
                "left": 4.450020399836802,
                "width": 31.053447572419405,
                "height": 18.381469679458682
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Fettine_Sceltissime_di_Bovino_Adulto_Cliente_1_1535448339.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_P9HbVjQ_jPJ6GNr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139417",
              "field1": "pollo",
              "field2": "sovracosce intere",
              "field3": "al kg",
              "field4": "",
              "description": "pollo sovracosce intere al kg",
              "grammage": 0,
              "price": "3.50",
              "price_label": "€ 3,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 77.55058796090438,
                "left": 4.450020399836802,
                "width": 46.85516115871071,
                "height": 19.07263068773838
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Sovracosce_di_Pollo_Cliente_1_1535465736_1536910282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dkKBP6g_Racy9Yx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165886",
              "field1": "martini ",
              "field2": "i gustorolli gr. 650  ",
              "field3": "di pollo -speck&formaggio",
              "field4": "di suino -spinaci&parmigiano -antichi sapori ",
              "description": "martini  i gustorolli gr. 650   di pollo -speck&formaggio di suino -spinaci&parmigiano -antichi sapori ",
              "grammage": 650,
              "price": "3.99",
              "price_label": "€ 3,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 77.91778502332788,
                "left": 51.30518155854752,
                "width": 46.37494900040802,
                "height": 18.70543362531488
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MARTINI_I_GUSTOROLLI_GR.650_1542121414.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MARTINI_I_GUSTOROLLI_DI_SUINO_GR.650_SPINACIPARM_1551721301.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DefUt02_j6lGMQQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 13,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0013_6rEVYCG.jpg",
          "products": [
            {
              "item_id": "141809",
              "field1": "suino",
              "field2": "arrosto in rete",
              "field3": "al kg",
              "field4": "",
              "description": "suino arrosto in rete al kg",
              "grammage": 0,
              "price": "6.50",
              "price_label": "€ 6,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 56.518206854345166,
                "width": 39.24092207262342,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/suino_pam_prova_1539696926_1554207269.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Y1fQml8_2SU36sL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165895",
              "field1": "bovino",
              "field2": "polpa per arrosto",
              "field3": "al kg",
              "field4": "",
              "description": "bovino polpa per arrosto al kg",
              "grammage": 0,
              "price": "8.90",
              "price_label": "€ 8,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 56.518206854345166,
                "width": 39.24092207262342,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/bovino_arrosto_1542992993.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WhqtOP7_QWhhZva.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131572",
              "field1": "amadori",
              "field2": "salsicce ricetta classica",
              "field3": "x 6",
              "field4": "gr. 430",
              "description": "amadori salsicce ricetta classica x 6 gr. 430",
              "grammage": 430,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 72.31992044063648,
                "width": 23.439208486332113,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/amadori_salsicce_pollo_e_tacchino_x_6_g430_1552665511.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_45TLvUm_tSDsT7P.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239424",
              "field1": "avimecc",
              "field2": "pollo ripieno",
              "field3": "gr. 1100 circa",
              "field4": "al kg",
              "description": "avimecc pollo ripieno gr. 1100 circa al kg",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 48.74903100775194,
                "width": 23.570889432884535,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/foto_pollo_ripieno_1606293985.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_I4PQk5L_m1LAjxS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166834",
              "field1": "avimecc ",
              "field2": "rollè di pollo",
              "field3": "vaschetta gr. 800 circa",
              "field4": " al kg",
              "description": "avimecc  rollè di pollo vaschetta gr. 800 circa  al kg",
              "grammage": 0,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 25.30982252141983,
                "width": 23.439208486332113,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/AVIMECC_ROLLEDI_POLLO_CONFEZIONATO_GR.800_CIRCA_1542639204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GQw0NgE_dXYFNfY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239423",
              "field1": "aia fuoco",
              "field2": "salsiccia paesana di suino x2 rotoli",
              "field3": "gr. 380",
              "field4": "",
              "description": "aia fuoco salsiccia paesana di suino x2 rotoli gr. 380",
              "grammage": 380,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 1.1851285189718481,
                "width": 24.124694002447978,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8008110270186_1605715246.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iHUVJJa_hMV2asD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197360",
              "field1": "amadori",
              "field2": "fesa di tacchino 10+ fette",
              "field3": "x 3 gr. 300 circa",
              "field4": "al kg",
              "description": "amadori fesa di tacchino 10+ fette x 3 gr. 300 circa al kg",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 1.1851285189718481,
                "width": 31.49882700938392,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/16551_Tacchino_Fesa_Fette_10_rt_1568638525_1573484340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Wlz9xTB_6RhM6lg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132725",
              "field1": "gusto ricco",
              "field2": "cotolette pollo",
              "field3": "x 8 - gr. 800",
              "field4": "-classiche -spinaci",
              "description": "gusto ricco cotolette pollo x 8 - gr. 800 -classiche -spinaci",
              "grammage": 800,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classiche",
                "Spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 1.1851285189718481,
                "width": 31.49882700938392,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Gustoricco_Cotoletta-pollox8_g800_1535450940_1550567983_1555408522.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GustoriccoCotolettapollox8g800_1548955983_1550567795_1555408523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_UWiE4YZ_ke7V2lM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131586",
              "field1": "agnello",
              "field2": "in tagli misti",
              "field3": "al kg",
              "field4": "",
              "description": "agnello in tagli misti al kg",
              "grammage": 0,
              "price": "8.90",
              "price_label": "€ 8,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 33.07899836801305,
                "width": 62.521368829049365,
                "height": 37.576499388004905
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Grigliata_mista_di_agnello_1432576618_1432820090_1477558317_14797430_E2rsV0G.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WWA7kLI_TWAr71n.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 14,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0014_9Q7bdpz.jpg",
          "products": [
            {
              "item_id": "134743",
              "field1": "findus ",
              "field2": "pisellini primavera",
              "field3": "gr. 750",
              "field4": "",
              "description": "findus  pisellini primavera gr. 750",
              "grammage": 750,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 10.77111383108935,
                "left": 4.504232966136264,
                "width": 18.40825173398613,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pisellini_primavera_750g_1_1580738822.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_EZAnzlJ_soVZCVr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165898",
              "field1": "gamberi",
              "field2": "argentini",
              "field3": "gr. 400",
              "field4": "",
              "description": "gamberi argentini gr. 400",
              "grammage": 400,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 10.77111383108935,
                "left": 22.912484700122395,
                "width": 17.145603835169315,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/vento_di_mare_GAMBERI_ARGENTINI_G400_1542047030.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_MhJXliI_nVqE7sZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137307",
              "field1": "dal peschereccio ",
              "field2": "misto per risotto e spaghetti ",
              "field3": "gr. 250",
              "field4": "",
              "description": "dal peschereccio  misto per risotto e spaghetti  gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 10.77111383108935,
                "left": 40.058088535291716,
                "width": 20.51514687882497,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/dal_peschereccio_misto_psgahetti_e_risotti_1588066449.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_o83TCoA_KQ63PET.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134742",
              "field1": "findus",
              "field2": "ciuffetti di spinaci primavera",
              "field3": "gr. 450",
              "field4": "",
              "description": "findus ciuffetti di spinaci primavera gr. 450",
              "grammage": 450,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 60.573235414116695,
                "width": 19.120818033455727,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/SPINACI_CIUFFETTI_450G_1600856065.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_xVNrZAz_uSsfj6K.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197272",
              "field1": "petrucci",
              "field2": "funghi misti con porcini",
              "field3": "kg. 1",
              "field4": "",
              "description": "petrucci funghi misti con porcini kg. 1",
              "grammage": 0,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 79.69405344757241,
                "width": 18.671613627090984,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/funghi_misto_bosco_con_porcini_1kg_1513268183_1573470829.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Ncyksmm_ETBmsxb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141818",
              "field1": "soavegel",
              "field2": "mozzarelline panate",
              "field3": "gr. 250",
              "field4": "",
              "description": "soavegel mozzarelline panate gr. 250",
              "grammage": 250,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 79.69405344757241,
                "width": 18.671613627090984,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Soavegel_Mozzarelline_250_g_1587488427.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_I8glVWN_XDv01vv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133906",
              "field1": "pizzoli",
              "field2": "patatine we love rustiche",
              "field3": "gr. 750",
              "field4": "",
              "description": "pizzoli patatine we love rustiche gr. 750",
              "grammage": 750,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 60.83659730722154,
                "width": 18.857456140350873,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Pizzoli_We_Love_Rustiche_Allegre_Casalinghe_750_g_1579533798_1596212919.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_s4LTdUA_gKwaLg2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137308",
              "field1": "findus ",
              "field2": "fiori merluzzo ",
              "field3": "x 4",
              "field4": "gr. 300",
              "description": "findus  fiori merluzzo  x 4 gr. 300",
              "grammage": 300,
              "price": "4.89",
              "price_label": "€ 4,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 39.7796817625459,
                "left": 79.69405344757241,
                "width": 18.40825173398613,
                "height": 19.583843329253366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/findus_fiori_di_merluzzo_1600245077_1600339166.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_IUIT6q8_NdTT2o7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140783",
              "field1": "aia",
              "field2": "cotolette di pollo",
              "field3": "surgelate",
              "field4": "gr. 280",
              "description": "aia cotolette di pollo surgelate gr. 280",
              "grammage": 280,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 60.704916360669124,
                "width": 18.59409424724602,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Aia_3_cotolette_filetti_pollo_280_g_1536576626.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TxtKpLS_KhJ8YwY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230675",
              "field1": "capitan findus",
              "field2": "bastoncini di merluzzo",
              "field3": "x 18",
              "field4": "gr. 450",
              "description": "capitan findus bastoncini di merluzzo x 18 gr. 450",
              "grammage": 450,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 42.03330273357814,
                "width": 18.671613627090984,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/64247-16291-46816_1600758455.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vhg9WEu_YjjpnO2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "168448",
              "field1": "buitoni",
              "field2": "forno di pietra",
              "field3": "",
              "field4": "-margherita gr. 300 -salamino piccante gr. 315 -prosciutto e funghi gr. 345",
              "description": "buitoni forno di pietra -margherita gr. 300 -salamino piccante gr. 315 -prosciutto e funghi gr. 345",
              "grammage": null,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Margherita",
                "Salamino piccante",
                "Prosciutto e funghi"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Preparati",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 23.175846593227263,
                "width": 18.857456140350873,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/59078_1540284738.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/59077_buitoni_pizza_forno_1539186083_1542047834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_5eWTDWZ_3Pfg6bu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133916",
              "field1": "frescofiore ",
              "field2": "panzerottini da friggere ",
              "field3": "gr. 500",
              "field4": "",
              "description": "frescofiore  panzerottini da friggere  gr. 500",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 4.504232966136276,
                "width": 18.671613627090984,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/IMG_20180727_105200_1535451283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_EXfLk6X_79Ch6ZT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239426",
              "field1": "sammontana",
              "field2": "barattolino",
              "field3": "spirito natalizio ",
              "field4": "gr. 410",
              "description": "sammontana barattolino spirito natalizio  gr. 410",
              "grammage": 410,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 59.363525091799254,
                "left": 4.504232966136276,
                "width": 37.10694614443085,
                "height": 37.576499388004905
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/64212_1604478560_1605715791.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_fruVVkB_fkWXKnz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165899",
              "field1": "marfrio",
              "field2": "tentacoli di totano vaschetta",
              "field3": "gr. 720",
              "field4": "",
              "description": "marfrio tentacoli di totano vaschetta gr. 720",
              "grammage": 720,
              "price": "5.79",
              "price_label": "€ 5,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 59.363525091799254,
                "left": 41.87454100367198,
                "width": 18.725775193798448,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MARFRIO_TENTACOLI_DI_TOTANO_G720_1573485883.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Tv3bJMu_slNhd7A.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197271",
              "field1": "vento di mare",
              "field2": "gamberi sgusciati precotti",
              "field3": "gr. 400",
              "field4": "",
              "description": "vento di mare gamberi sgusciati precotti gr. 400",
              "grammage": 400,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 59.363525091799254,
                "left": 60.86367809057528,
                "width": 18.671613627090984,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/vento_di_mare_1573485998.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_d4TY3k8_7Hkgbsa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130318",
              "field1": "magnum",
              "field2": "bomboniera",
              "field3": "x 12 - gr. 104",
              "field4": "",
              "description": "magnum bomboniera x 12 - gr. 104",
              "grammage": 104,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classic",
                "Classic almond white",
                "Caffè"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 59.363525091799254,
                "left": 79.53529171766625,
                "width": 18.462413300693594,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/algida_magnum_bomboniera_classica_1495097234_1495880317_1508238974_1_d22ZmsX.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/algida_magnum_bomboniera_classic_almond_white_1495097233_1495880317__lf6PTQL.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sdxXtwT_IkXvaTk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130339",
              "field1": "viennetta",
              "field2": "vaniglia",
              "field3": "gr. 360",
              "field4": "",
              "description": "viennetta vaniglia gr. 360",
              "grammage": 360,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 79.53529171766625,
                "width": 18.462413300693594,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VIENNETTA_VANIGLIA_GR.360_1552665745.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Gr0YCTp_6q5E3nw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131654",
              "field1": "tutta natura ",
              "field2": "sorbetto x 4 flutes ",
              "field3": "gr. 260",
              "field4": "-limonetto -caffè",
              "description": "tutta natura  sorbetto x 4 flutes  gr. 260 -limonetto -caffè",
              "grammage": 260,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Limonetto",
                "Caffè"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 60.73199714402285,
                "width": 18.803294573643413,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TUTTA_NATURA_SORBETTO_LIMONETTO_x_4_g260_1530893390.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jcZCmiO_9DhuNwV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134736",
              "field1": "sammontana\t",
              "field2": "torta gelato st. honorè",
              "field3": "gr. 750",
              "field4": "",
              "description": "sammontana\t torta gelato st. honorè gr. 750",
              "grammage": 750,
              "price": "4.79",
              "price_label": "€ 4,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Dolci",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 42.0062219502244,
                "width": 18.725775193798448,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/SAMMONTANA_TORTA_GELATO_ST.HONORE_GR.750_1554197407.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_KpdJYt0_VZEN2y1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 15,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0015_yiICsRR.jpg",
          "products": [
            {
              "item_id": "130357",
              "field1": "galbanella",
              "field2": "mortadellina",
              "field3": "gr. 430 ",
              "field4": "",
              "description": "galbanella mortadellina gr. 430 ",
              "grammage": 430,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 11.75030599755202,
                "left": 2.1068951448388415,
                "width": 29.786974704202365,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Galbanella_430_gr_con_ricette_1472142422_1472220203_1475222104_15585_OKnPkUF.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_VOQSQS7_Xq6yEbM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134774",
              "field1": "parmareggio",
              "field2": "fettine al parmigiano reggiano",
              "field3": "gr. 150",
              "field4": "",
              "description": "parmareggio fettine al parmigiano reggiano gr. 150",
              "grammage": 150,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 11.75030599755202,
                "left": 31.893869849041202,
                "width": 26.17742758057936,
                "height": 28.763769889840884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/33582_ParmareggioFettine150gr_1573660568_1574096692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_r4NuTG5_fO7PXSX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131662",
              "field1": "vallelata",
              "field2": "ricotta fresca",
              "field3": "gr. 250",
              "field4": "",
              "description": "vallelata ricotta fresca gr. 250",
              "grammage": 250,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 58.07129742962057,
                "width": 18.857456140350873,
                "height": 17.99265605875153
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ricotta_vallelata_250_con_bs_1525698844_1525707185.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sR9zTOT_nxhC3uW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165901",
              "field1": "paysan breton ",
              "field2": "camembert",
              "field3": "gr. 250",
              "field4": "",
              "description": "paysan breton  camembert gr. 250",
              "grammage": 250,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 77.45547735618115,
                "width": 18.276570787433702,
                "height": 17.99265605875153
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PAYSAN_BRETON_Camembert__250g_1542047312.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JWCpDGI_sbpyqcr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134765",
              "field1": "galbani",
              "field2": "galbanino formaggio dolce",
              "field3": "gr. 550",
              "field4": "",
              "description": "galbani galbanino formaggio dolce gr. 550",
              "grammage": 550,
              "price": "3.89",
              "price_label": "€ 3,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 77.45547735618115,
                "width": 18.276570787433702,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/galbanino_1574845320_1575905599_1584604530.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_67Vu9P4_GHPFCVM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134779",
              "field1": "parmareggio",
              "field2": "burro",
              "field3": "gr. 200",
              "field4": "",
              "description": "parmareggio burro gr. 200",
              "grammage": 200,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.90208078335373,
                "left": 77.45547735618115,
                "width": 18.276570787433702,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/447025_parmareggio_BURRO_200g_1563528313_1573492800.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dDWeZtO_63GvmYO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170717",
              "field1": "parmareggio",
              "field2": "parmigiano reggiano petali",
              "field3": "gr. 80",
              "field4": "",
              "description": "parmareggio parmigiano reggiano petali gr. 80",
              "grammage": 80,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.90208078335373,
                "left": 58.598021215830265,
                "width": 18.857456140350873,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/1583422424_812042-0010-petali-parmareggio-100g_1593685120_1595319197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8Kq4ZWk_QNMalLH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170685",
              "field1": "gran soresina",
              "field2": "grana padano",
              "field3": "oltre 16 mesi",
              "field4": "gr. 200",
              "description": "gran soresina grana padano oltre 16 mesi gr. 200",
              "grammage": 200,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.90208078335373,
                "left": 39.79472664218686,
                "width": 18.803294573643413,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Grana_Padano_Gran_Soresina_16M_200_gr_1540915752.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iQxwc2i_7ouOhKn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232961",
              "field1": "galbani",
              "field2": "galbanino",
              "field3": "a fette",
              "field4": "gr. 120 ",
              "description": "galbani galbanino a fette gr. 120 ",
              "grammage": 120,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.90208078335373,
                "left": 20.67390860873113,
                "width": 18.725775193798448,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/56076_1513849287_1563355768_1586271150_1586271236_1600687229.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_xoGp1gJ_8HWsWsh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130330",
              "field1": "santa lucia galbani",
              "field2": "mascarpone",
              "field3": "gr. 500",
              "field4": "",
              "description": "santa lucia galbani mascarpone gr. 500",
              "grammage": 500,
              "price": "3.89",
              "price_label": "€ 3,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.90208078335373,
                "left": 1.8706140350877167,
                "width": 18.013208894328848,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Mascarpone_Santa_Lucia_500g_1478248975.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_y4YKyhG_TlGrjC6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131673",
              "field1": "gran soresina ",
              "field2": "grana padano grattugiato ",
              "field3": "gr. 200",
              "field4": "",
              "description": "gran soresina  grana padano grattugiato  gr. 200",
              "grammage": 200,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 1.8706140350877167,
                "width": 29.864494084047333,
                "height": 37.69889840881273
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Gran_Soresina_grana_dop_grattugiato_200_g_1436191883.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/gran_soresina_GRANA_PADANO_GRATTUGIATO_GR.200_1537354420.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_m9xcdtg_OJLfQDV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239427",
              "field1": "soresina",
              "field2": "burro",
              "field3": "gr. 250",
              "field4": "",
              "description": "soresina burro gr. 250",
              "grammage": 250,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 31.735108119135052,
                "width": 26.626631986944105,
                "height": 37.69889840881273
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8004673220118_1604074462_1605715880.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_2JNUp6f_YNG9tT6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162512",
              "field1": "foglia d'oro",
              "field2": "margarina",
              "field3": "gr. 250",
              "field4": "",
              "description": "foglia d'oro margarina gr. 250",
              "grammage": 250,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 58.36174010607915,
                "width": 18.80329457364341,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Gradina_Foglia_Oro_Panetto_250_gr_1526915211.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_SATMnOh_STh2dqY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215574",
              "field1": "veroni",
              "field2": "fette prosciutto cotto",
              "field3": "alta qualità",
              "field4": "vaschetta gr. 80",
              "description": "veroni fette prosciutto cotto alta qualità vaschetta gr. 80",
              "grammage": 80,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 77.16503467972257,
                "width": 18.594094247246023,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/N362F-1_1593018089.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_uaLi9T3_q3iAb7a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215552",
              "field1": "bisanzio",
              "field2": "pancetta cubetti",
              "field3": "-dolce -affumicata",
              "field4": "gr. 100",
              "description": "bisanzio pancetta cubetti -dolce -affumicata gr. 100",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Dolce",
                "Affumicata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 77.16503467972257,
                "width": 18.594094247246023,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/bisanzio_Carbonara_Pancetta_affumicata_a_cubetti_100_g_1593679772.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/bisanzio_Pancetta_dolce_a_cubetti_100_g_1593679773.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_NiIbTN4_AQnLPeb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "218453",
              "field1": "san vincenzo",
              "field2": "coppia",
              "field3": "spianata+provola fette",
              "field4": "gr. 100",
              "description": "san vincenzo coppia spianata+provola fette gr. 100",
              "grammage": 100,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 58.23005915952673,
                "width": 18.934975520195838,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/SAN_VINCENZO_coppia_spianata_e_provola_affettati_1596807179.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jphHTSM_9RBD384.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137320",
              "field1": "certosino",
              "field2": "crescenza",
              "field3": "gr. 100",
              "field4": "",
              "description": "certosino crescenza gr. 100",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 58.36174010607916,
                "width": 18.539932680538556,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Certosa_100_1531739923_1532623951_1533725395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vrNZY55_9ReGAj6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 16,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0016_ghVmT1A.jpg",
          "products": [
            {
              "item_id": "215573",
              "field1": "veroni",
              "field2": "fette prosciutto crudo ",
              "field3": "vaschetta gr. 80",
              "field4": "",
              "description": "veroni fette prosciutto crudo  vaschetta gr. 80",
              "grammage": 80,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 4.372552019583848,
                "width": 26.96751325989392,
                "height": 36.8421052631579
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/N220F-1_1593017922.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aRNNZqO_JKb8b78.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131728",
              "field1": "rana",
              "field2": "lasagne all'uovo sfogliagrezza",
              "field3": "gr. 250",
              "field4": "",
              "description": "rana lasagne all'uovo sfogliagrezza gr. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 31.340065279477766,
                "width": 29.655293757649943,
                "height": 36.8421052631579
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rana_Lasagne_Sfogliagrezza_1544035954_1544202777_1549279644_15496180_mDbeqow.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_v2UA7UQ_yEmOgMd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137337",
              "field1": "negroni ",
              "field2": "cotto in cubetti",
              "field3": "gr. 120",
              "field4": "",
              "description": "negroni  cotto in cubetti gr. 120",
              "grammage": 120,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 60.99535903712771,
                "width": 18.803294573643406,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/86504_Cubetti_Prosciutto_Cotto_120g_2018_rifl_1550231181.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Y5iLqse_MXtqArD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "212158",
              "field1": "clai",
              "field2": "salametto golosetto in busta",
              "field3": "gr. 100",
              "field4": "",
              "description": "clai salametto golosetto in busta gr. 100",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 3.3047735618115057,
                "left": 79.79865361077113,
                "width": 19.779222766217874,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CLAI_SALAME_GOLOSETTO_GR.100_1570210000_1588867794.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dwteJ6K_UzSQhDW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "178415",
              "field1": "beretta",
              "field2": "wurstel classici di suino",
              "field3": "x 4 - gr.100",
              "field4": "",
              "description": "beretta wurstel classici di suino x 4 - gr.100",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 80.06201550387598,
                "width": 19.51586087311302,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Beretta_4_wurstel_classici_100_g.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_qxwegMZ_DcBApMX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131709",
              "field1": "aia wudy ",
              "field2": "wurstel con formaggio ",
              "field3": "x 3 - gr. 150",
              "field4": "",
              "description": "aia wudy  wurstel con formaggio  x 3 - gr. 150",
              "grammage": 150,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 60.99535903712771,
                "width": 19.06665646674826,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Aia_Wudy_wurstel_formaggio_150_g_1537377280_1537377306_1554972732_1576148614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0Sw9X2D_sjutmVS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "191384",
              "field1": "milk",
              "field2": "kefir cremoso",
              "field3": "gr. 150",
              "field4": "-bianco dolce -mirtillo -avena e noci",
              "description": "milk kefir cremoso gr. 150 -bianco dolce -mirtillo -avena e noci",
              "grammage": 150,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianco dolce",
                "Mirtillo",
                "Avena e noci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 82.95899632802937,
                "width": 15.302070583435336,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/60747_1562766269_1569580278.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MILK_KEFIR_CREM_MIRTILLO_GR150_1565109067_1569580323.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_HWvIODt_x2JncFR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "188651",
              "field1": "pam",
              "field2": "pasta fresca all'uovo",
              "field3": "gr. 250",
              "field4": "",
              "description": "pam pasta fresca all'uovo gr. 250",
              "grammage": 250,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tagliatelle",
                "Fettuccine"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 67.18436352509181,
                "width": 15.37958996328029,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3253761_pam_pasta_fresca_uovo_g250_tagliatelle_1567407523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_12tetYX_3dH7B1v.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231049",
              "field1": "fattoria tambaro",
              "field2": "uova allevate a terra",
              "field3": "x6",
              "field4": "medie",
              "description": "fattoria tambaro uova allevate a terra x6 medie",
              "grammage": 0,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 51.35556915544676,
                "width": 15.828794369645047,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/uova_1512641449_1569483091_1602314349.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_d92DErc_z9bDvvZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130095",
              "field1": "rana",
              "field2": "-pesto fresco gr. 140",
              "field3": "-sugo fresco gr. 180",
              "field4": "vari gusti",
              "description": "rana -pesto fresco gr. 140 -sugo fresco gr. 180 vari gusti",
              "grammage": 0,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pesto fresco",
                "Sugo fresco"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Vegetali",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 35.844298245614034,
                "width": 15.511270909832717,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/RANA_pesto_fresco_GENOVESE_140g_1488874245.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/RANA_NOCI_140_1486465025_1497516781_1587129542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rana_Pesto_Senzaglio_DOP_140g_1578592200_1587129543.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_31bH0YA_NtM2bUp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185305",
              "field1": "pam",
              "field2": "pasta rotolo",
              "field3": "gr. 230",
              "field4": "-sfoglia -brisée",
              "description": "pam pasta rotolo gr. 230 -sfoglia -brisée",
              "grammage": 230,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Sfoglia",
                "Brisée"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 20.278865769073843,
                "width": 15.565432476540193,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000517_PAM_PASTA_BRISEE_ROTOLO_G230_1563527196.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000519_PAM_PASTA_SFOGLIA_ROTOLO_GR.230_1562605405_1605720304.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GMsCFlF_v8oZnZL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "192504",
              "field1": "citterio",
              "field2": "gli irresistibili",
              "field3": "salamini",
              "field4": "gr. 75",
              "description": "citterio gli irresistibili salamini gr. 75",
              "grammage": 75,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 4.109190126478985,
                "width": 16.169675642594857,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cover-irresistibili-salaminilegno_1548062936_1570799675.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ApmZC5f_VPGy9RI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180528",
              "field1": "pastificio astorino",
              "field2": "pasta fresca di semola gr. 500",
              "field3": "",
              "field4": "",
              "description": "pastificio astorino pasta fresca di semola gr. 500",
              "grammage": 500,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Maccheroncino",
                "Paccheri lisci",
                "Scialatielli",
                "Tagliarini",
                "Cavatelli rigati",
                "Maccheroni inferriati",
                "Trofie",
                "Calamarata liscia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 59.24112607099142,
                "left": 4.635913912688696,
                "width": 37.50198898408812,
                "height": 19.951040391676866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/6Z8A9168_1558954118.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/6Z8A9182_1558954119.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/6Z8A9138_1575022404.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DZUERnq_l21bj3V.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132561",
              "field1": "zappalà",
              "field2": "mozzarelle tris",
              "field3": "gr. 300",
              "field4": "",
              "description": "zappalà mozzarelle tris gr. 300",
              "grammage": 300,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 79.1921664626683,
                "left": 4.635913912688696,
                "width": 37.50198898408812,
                "height": 17.38066095471236
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/latterie_di_zappala_mozzarelle_tris_g300_1532338932.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_7D2DmMs_lnhleYJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130340",
              "field1": "actimel ",
              "field2": "gr. 100 x 6",
              "field3": "vari gusti",
              "field4": "",
              "description": "actimel  gr. 100 x 6 vari gusti",
              "grammage": 600,
              "price": "2.39",
              "price_label": "€ 2,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianco",
                "Fragola"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 42.13790289677682,
                "width": 19.120818033455738,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Actimel_6x_bianco_1549293965_1554135338_1563814738.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Actimel_6x_fragola_1549293966_1554135339_1563814739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0D7sxJ6_TqX3gVI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "200518",
              "field1": "cameo",
              "field2": "muu muu budino vaniglia",
              "field3": "+ confetti al cioccolato",
              "field4": "gr. 125",
              "description": "cameo muu muu budino vaniglia + confetti al cioccolato gr. 125",
              "grammage": 125,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 61.258720930232556,
                "width": 18.408251733986127,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cameo_muu_muu_confetti_cioccolato_1570027661_1575309691.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TcIeymC_mSFDtDB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133958",
              "field1": "fruttolo",
              "field2": "formaggio alla frutta",
              "field3": "gr. 50 x 6",
              "field4": "Fragola banana e pera",
              "description": "fruttolo formaggio alla frutta gr. 50 x 6 Fragola banana e pera",
              "grammage": 300,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fragola banana e pera",
                "Misti"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 79.93033455732353,
                "width": 18.4624133006936,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3D_Fruttolo_6x50g_Mista_100Naturale_1551439332.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3D_Fruttolo_6x50g_Singola_100Naturale_1551439332.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ukb6WKX_FA8ySXq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140873",
              "field1": "perugina",
              "field2": "nuvole dessert fresco",
              "field3": "gr. 60 x 4",
              "field4": "-cioccolato -fiordilatte",
              "description": "perugina nuvole dessert fresco gr. 60 x 4 -cioccolato -fiordilatte",
              "grammage": 240,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cioccolato",
                "Fiordilatte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Snack",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 79.93033455732353,
                "width": 18.4624133006936,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/perugina_Nuvole_Fiordilatte_1519832525_1519832648.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NUVOLE_CIOCCCOLATO_AL_LATTE_1568387931_1571676174_1589992901.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ZgIMlEb_AnxrbxE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131690",
              "field1": "granarolo",
              "field2": "yogurt cremoso alla frutta",
              "field3": "gr. 125 x 8",
              "field4": "",
              "description": "granarolo yogurt cremoso alla frutta gr. 125 x 8",
              "grammage": 0,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 61.522082823337406,
                "width": 18.408251733986127,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/AQ_Yog_FILIERA_x8_1574076567.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_65va5lq_EGMI0cn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131693",
              "field1": "mevgal ",
              "field2": "crema di yogurt greco bianco extra ",
              "field3": "gr. 150 ",
              "field4": "-classico -0%",
              "description": "mevgal  crema di yogurt greco bianco extra  gr. 150  -classico -0%",
              "grammage": 150,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "0%"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 42.532945736434094,
                "width": 18.989137086903312,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MEVGAL_BIANCO_g150_Extra-Extra_0_1531123579_1531130385.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_O6zZrU0_NVqEHLR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 17,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0017_oAqh79f.jpg",
          "products": [
            {
              "item_id": "131677",
              "field1": "petti",
              "field2": "passata di pomodoro",
              "field3": "extrafine",
              "field4": "gr. 700 ",
              "description": "petti passata di pomodoro extrafine gr. 700 ",
              "grammage": 700,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 9.791921664626683,
                "left": 1.9752141982863987,
                "width": 14.511984904120773,
                "height": 30.354957160342718
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PETTI_Passata_extrafine_Il_delicato_700g_1554197146.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_OPF3p82_8bDv2WM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131686",
              "field1": "la masseria",
              "field2": "olio extra vergine di oliva",
              "field3": "lt. 1",
              "field4": "",
              "description": "la masseria olio extra vergine di oliva lt. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 9.791921664626683,
                "left": 16.48719910240717,
                "width": 16.82808037535699,
                "height": 30.354957160342718
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/la_masseria_olio_evo_1_lt_1587546192.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_7HADg01_hpZStwo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "208430",
              "field1": "ponti",
              "field2": "glassa all'aceto balsamico igp",
              "field3": "gr. 500",
              "field4": "",
              "description": "ponti glassa all'aceto balsamico igp gr. 500",
              "grammage": 500,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 17.54064667482659,
                "width": 15.774632802937573,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8001010079576_1595320282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_z6N1CiM_cEU4z0S.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185320",
              "field1": "de nigris",
              "field2": "aceto balsamico di modena igp",
              "field3": "ml. 250",
              "field4": "",
              "description": "de nigris aceto balsamico di modena igp ml. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 1.8435332517339713,
                "width": 15.69711342309262,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DENIGRIS_BALSAMICO_ML.250_1563527362.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_rWhQSkt_0cMPHof.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166862",
              "field1": "mulino bianco ",
              "field2": "pancarrè 16 fette ",
              "field3": "gr. 285",
              "field4": "",
              "description": "mulino bianco  pancarrè 16 fette  gr. 285",
              "grammage": 285,
              "price": "0.50",
              "price_label": "€ 0,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.36352509179927,
                "left": 1.8435332517339713,
                "width": 31.3671460628315,
                "height": 37.2093023255814
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mulino_bianco_Pancarre_16_fette_1531132693_1542644150.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wfBN8FJ_v3WOqCE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230695",
              "field1": "daily bread",
              "field2": "pagnotta pan rustico",
              "field3": "ai cereali",
              "field4": "gr. 400",
              "description": "daily bread pagnotta pan rustico ai cereali gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 33.210679314565475,
                "width": 15.642951856385144,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DailyBread_pan_rustico_ai_cereali_1597136735_1597314754_1597314769.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mnTMr1Z_DZxf9Th.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139554",
              "field1": "pam ",
              "field2": "tonno al naturale ",
              "field3": "gr. 80 x 3",
              "field4": "",
              "description": "pam  tonno al naturale  gr. 80 x 3",
              "grammage": 240,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 33.210679314565475,
                "width": 15.642951856385144,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000167_pam_tonno_naturale_g80x3_1560242130.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_bEAA06A_Gqefzhe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202066",
              "field1": "belvedere",
              "field2": "olio di semi di girasole",
              "field3": "lt. 1",
              "field4": "",
              "description": "belvedere olio di semi di girasole lt. 1",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 33.210679314565475,
                "width": 15.642951856385144,
                "height": 19.216646266829866
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BELVEDERE_girasole_2019__1576854927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_MrTPqzy_Djv91Oy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140915",
              "field1": "mutti",
              "field2": "passata di pomodoro",
              "field3": "al basilico",
              "field4": "gr. 700",
              "description": "mutti passata di pomodoro al basilico gr. 700",
              "grammage": 700,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 22.031823745410033,
                "left": 33.210679314565475,
                "width": 15.642951856385144,
                "height": 17.99265605875153
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/MUTTI_PASSATA_DI_POMODORO_AL_BASILICO_GR.700_1537265812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vsGOQyx_lyCrbLy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141929",
              "field1": "barilla",
              "field2": "gr.400",
              "field3": "-sugo amatriciana -ragù bolognese",
              "field4": "-ragù contadino -ragù montanaro",
              "description": "barilla gr.400 -sugo amatriciana -ragù bolognese -ragù contadino -ragù montanaro",
              "grammage": 400,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Sugo amatriciana",
                "Ragù bolognese",
                "Ragù contadino",
                "Ragù montanaro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 3.427172582619332,
                "left": 33.210679314565475,
                "width": 15.642951856385144,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Amatriciana_400g_it_1543919652_1562144913_1570803803.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Ragu_bolognese_400g_it_1543919651_1562144914_1570803804.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dybjpMM_fuuVghv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131674",
              "field1": "mutti",
              "field2": "polpa in pezzi",
              "field3": "-di pomodoro gr. 400 x 3",
              "field4": "-di datterini gr. 300 x 3",
              "description": "mutti polpa in pezzi -di pomodoro gr. 400 x 3 -di datterini gr. 300 x 3",
              "grammage": 0,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pomodoro",
                "Datterini"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 3.427172582619332,
                "left": 48.853631170950614,
                "width": 47.19594043247656,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/70156142_Polpa_Datterini_3x300g_cod._55142_1559553008_1568130081_1596210894.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Mutti_Polpa_gr_400_x_3_1526027188_1541496468_1561365703_1596210896.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_bG72aBV_3L782q3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216410",
              "field1": "rossogargano",
              "field2": "pomodori pelati di puglia",
              "field3": "gr. 800",
              "field4": "",
              "description": "rossogargano pomodori pelati di puglia gr. 800",
              "grammage": 800,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 22.031823745410033,
                "left": 48.853631170950614,
                "width": 15.855875152998793,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ROSSOGARGANO_Pomodoro_Pelato_800_gr_1594202324.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wZ9Bc4l_hTq0nG8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134013",
              "field1": "delicius ",
              "field2": "vongole al naturale ",
              "field3": "gr. 130",
              "field4": "",
              "description": "delicius  vongole al naturale  gr. 130",
              "grammage": 130,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.14687882496939,
                "left": 48.853631170950614,
                "width": 15.855875152998793,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/DELICIUS_VONGOLE_NATURALE_g130_1532351597.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JzqKif8_kG7ihJa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134818",
              "field1": "rio mare",
              "field2": "filetti di tonno",
              "field3": "gr. 180",
              "field4": "",
              "description": "rio mare filetti di tonno gr. 180",
              "grammage": 180,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Piccanti",
                "Al naturale",
                "Olio d'oliva"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 58.99632802937576,
                "left": 48.853631170950614,
                "width": 15.855875152998793,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/rio_mare_filetti_di_tonno_olio_oliva_1447870210.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_f9PNZAF_Nr3bLyi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "200527",
              "field1": "scotti",
              "field2": "le bio croccanti risette riso e mais",
              "field3": "gr. 150",
              "field4": "",
              "description": "scotti le bio croccanti risette riso e mais gr. 150",
              "grammage": 150,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 48.853631170950614,
                "width": 15.855875152998793,
                "height": 19.461444308445532
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8001860259869_1575310599.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wsHwFIJ_p3iQx6n.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "217345",
              "field1": "liguori",
              "field2": "pasta gragnano igp",
              "field3": "gr. 500",
              "field4": "varie trafile",
              "description": "liguori pasta gragnano igp gr. 500 varie trafile",
              "grammage": 500,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 64.7095063239494,
                "width": 15.747552019583827,
                "height": 19.461444308445532
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pasta-liguori_1595315090.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/90005396_XL1_1595315091.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_S7U80SB_06JAOlM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "198203",
              "field1": "biffi",
              "field2": "salsa tonnata",
              "field3": "tubo gr. 145",
              "field4": "",
              "description": "biffi salsa tonnata tubo gr. 145",
              "grammage": 145,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 64.7095063239494,
                "width": 15.747552019583827,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Biffi_salsa_tonnata_tubo_gr.145_1574099385.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_RzKbPkj_J97q1tE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166856",
              "field1": "mareblu ",
              "field2": "filetti di sgombro ",
              "field3": "gr. 90 ",
              "field4": "",
              "description": "mareblu  filetti di sgombro  gr. 90 ",
              "grammage": 90,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Olio d'oliva",
                "Piccanti",
                "Affumicati"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.26927784577724,
                "left": 64.7095063239494,
                "width": 15.747552019583827,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Mareblu_Sgombri_Affumicati_90_g_1467984763_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Mareblu_Sgombri_Olio_90_g_1467984795_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Mareblu_Sgombri_Piccanti_90_g_1467984773_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GTcojjJ_RkRxFJU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "233740",
              "field1": "buscema",
              "field2": "piccantina alla calabrese",
              "field3": "gr. 280",
              "field4": "",
              "description": "buscema piccantina alla calabrese gr. 280",
              "grammage": 280,
              "price": "2.39",
              "price_label": "€ 2,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.78702570379437,
                "left": 64.7095063239494,
                "width": 15.747552019583827,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/000057972_1601650980.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aHehrBh_RTpoIzo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185464",
              "field1": "saclà",
              "field2": "sottoli cuori di carciofo",
              "field3": "gr. 285",
              "field4": "",
              "description": "saclà sottoli cuori di carciofo gr. 285",
              "grammage": 285,
              "price": "3.19",
              "price_label": "€ 3,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.78702570379437,
                "left": 80.45705834353323,
                "width": 15.329151366789084,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/M_sottoli_cuori-di-carciofi_1593020411_1593160712.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_uv3Xfps_9FhUugV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131464",
              "field1": "mare aperto",
              "field2": "tonno all'olio di oliva ",
              "field3": "gr. 80 x 8",
              "field4": "",
              "description": "mare aperto tonno all'olio di oliva  gr. 80 x 8",
              "grammage": 640,
              "price": "4.89",
              "price_label": "€ 4,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.26927784577724,
                "left": 80.45705834353323,
                "width": 15.329151366789084,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mare_aperto_tonno_olio_oliva_g._80_x_8_1503931904_1506332972.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_xpU1AWs_zXqny4Y.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134673",
              "field1": "gran pavesi",
              "field2": "i cracker",
              "field3": "gr. 280",
              "field4": "",
              "description": "gran pavesi i cracker gr. 280",
              "grammage": 280,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pomodoro",
                "Olive"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 80.45705834353323,
                "width": 15.329151366789084,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/55621_1510309452.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/55622_1510309453.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_d5ji0FR_jdWdMwg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239429",
              "field1": "di bari",
              "field2": "pasta di semola trafilata al bronzo",
              "field3": "",
              "field4": "gr. 250",
              "description": "di bari pasta di semola trafilata al bronzo gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tagliolini funghi",
                "Tagliolini limone",
                "Spaghetti al nero di seppia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 80.45705834353323,
                "width": 15.329151366789084,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TAGLIOLINA_AL_LIMONE_1606316195.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TAGLIOLINA_AI_FUNGHI_PORCINI_1606316196.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/SPAGHETTI_AL_NERO_DI_SEPPIA_1606316198.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sfGMRF2_7FdnIHz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 18,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0018_vbTjNHk.jpg",
          "products": [
            {
              "item_id": "134822",
              "field1": "knorr ",
              "field2": "brodo granulare",
              "field3": "gr. 150",
              "field4": "",
              "description": "knorr  brodo granulare gr. 150",
              "grammage": 150,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Pesce",
                "Verdure"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 11.995104039167687,
                "left": 4.213790289677683,
                "width": 11.378722970216257,
                "height": 17.013463892288865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Classico_150_g_1570004948_1574097205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Pesce_150_g_1570004942_1574097206.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Vegetale_150_g_1570004941_1574097208.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ZFX64o7_eXg5xff.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239428",
              "field1": "knorr",
              "field2": "soffritto pronto",
              "field3": "",
              "field4": "gr. 130",
              "description": "knorr soffritto pronto gr. 130",
              "grammage": 130,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Cipolla"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 29.00856793145655,
                "left": 4.213790289677683,
                "width": 21.123113015095896,
                "height": 11.015911872705017
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Knorr_Soffritto_Cipolla_1603121860_1604336597_1604336632_1605715916.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Knorr_Soffritto_Classico_1603121861_1604336598_1604336633_1605715917.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_MXcmxoc_56ODyVw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141879",
              "field1": "lipton ",
              "field2": "the yellow label",
              "field3": "25 filtri",
              "field4": "",
              "description": "lipton  the yellow label 25 filtri",
              "grammage": 0,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 22.031823745410033,
                "left": 18.43533251733986,
                "width": 21.123113015095896,
                "height": 7.099143206854344
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Lipton_yellow_label_1535124645_1539598111.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_EFX5sIc_teYdJD5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139564",
              "field1": "calvè",
              "field2": "salsa squeeze",
              "field3": "ml. 250",
              "field4": "",
              "description": "calvè salsa squeeze ml. 250",
              "grammage": 250,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Barbecue",
                "Burger"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 12.117503059975517,
                "left": 15.011627906976743,
                "width": 16.11923704610365,
                "height": 10.77111383108935
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/calve_barbecue_250_ml_1554807655_1570803866.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/calve_burger_250_ml_1554807654_1570803867.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9kMJ42O_IDGNF8v.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "203231",
              "field1": "calvé ",
              "field2": "ketchup",
              "field3": "ml. 250",
              "field4": "",
              "description": "calvé  ketchup ml. 250",
              "grammage": 250,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 12.117503059975517,
                "left": 31.130864953080394,
                "width": 11.007037943696433,
                "height": 10.77111383108935
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Ketchup_Standard_2018_1523614892_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/KETCHUP_PICCANTE_2018_1523614893_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_XGL4DdY_HdPeoMb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130207",
              "field1": "calvè",
              "field2": "maionese ",
              "field3": "vaso",
              "field4": "ml. 500",
              "description": "calvè maionese  vaso ml. 500",
              "grammage": 500,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 28.763769889840876,
                "left": 25.336903304773582,
                "width": 16.669318645450822,
                "height": 11.260709914320685
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/62003_Calve_Classica_maionese_500_ml_1429275510_1518105476.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_2PK3d0m_joq5zGP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134068",
              "field1": "eridania",
              "field2": "tropical zucchero di canna",
              "field3": "sacchetto kg. 1",
              "field4": "",
              "description": "eridania tropical zucchero di canna sacchetto kg. 1",
              "grammage": 0,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.391676866585065,
                "left": 4.136270909832739,
                "width": 18.512851897184802,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ERIDANIA_TROPICAL_ZUCCHERO_DI_CANNA_SACCHETTO_KG1_1532342371.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_RO0DQM8_j5hFvvN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "171383",
              "field1": "select",
              "field2": "farro perlato",
              "field3": "astuccio gr. 400",
              "field4": "",
              "description": "select farro perlato astuccio gr. 400",
              "grammage": 400,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 4.136270909832739,
                "width": 18.512851897184802,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Select_Farro_Perlato_Scatola_400_g_1470735248_1492853405_1499673407.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Dvnwfqk_AteiNvS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130211",
              "field1": "pontI",
              "field2": "funghi alla pizzaiola",
              "field3": "gr. 280",
              "field4": "",
              "description": "pontI funghi alla pizzaiola gr. 280",
              "grammage": 280,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 4.136270909832739,
                "width": 18.512851897184802,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PONTI_FUNGHI_ALLA_PIZZAIOLA__GR.280_1595320859.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_EFjuxQW_lfDfwxM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239946",
              "field1": "rienzi                                                                         ",
              "field2": "pane grattugiato ",
              "field3": "kg.1",
              "field4": "",
              "description": "rienzi                                                                          pane grattugiato  kg.1",
              "grammage": 1000,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.024479804161565,
                "left": 22.966646266829883,
                "width": 19.039575683394517,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Rienzi_grattugiato_kg.1_1606500455.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_dnF3Bu0_DgxfqDx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "186726",
              "field1": "buscema",
              "field2": "funghi misti alla calabrese",
              "field3": "in olio",
              "field4": "gr. 550",
              "description": "buscema funghi misti alla calabrese in olio gr. 550",
              "grammage": 550,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 22.966646266829883,
                "width": 19.039575683394517,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/BUSCEMA_FUGHI_MISTI_1565258132.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ADeP614_LKBvjvo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134041",
              "field1": "alisa ",
              "field2": "olive lattina",
              "field3": "-nere intere gr. 425",
              "field4": "-nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "description": "alisa  olive lattina -nere intere gr. 425 -nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Nere intere",
                "Nere snocciolate",
                "Verdi snocciolate"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 22.966646266829883,
                "width": 19.039575683394517,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/alisa_olive_nere_intere_1498500062_1589539308.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/AlisaOliveVerdiDenocc_1533030532_1589539309.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_G5jgLkl_m8bDwau.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132613",
              "field1": "del monte",
              "field2": "ananas sciroppate a fette ",
              "field3": "gr. 435",
              "field4": "",
              "description": "del monte ananas sciroppate a fette  gr. 435",
              "grammage": 435,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 42.0062219502244,
                "width": 18.884536923704626,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Ananas_Naturale_Fette_565g_1478792574_1503568368.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Yr6MWtN_fyo78Dz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134846",
              "field1": "select",
              "field2": "legumi lessati",
              "field3": "gr. 360",
              "field4": "-fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "description": "select legumi lessati gr. 360 -fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "grammage": 360,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fagioli borlotti",
                "Fagioli cannellini",
                "Fagioli tondini",
                "Ceci messico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 42.0062219502244,
                "width": 18.884536923704626,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Select_Fagioli_Borlotti_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Select_Fagioli_Cannellini_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JcQhWv0_pcPT3kM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134825",
              "field1": "pam",
              "field2": "panna da cucina ",
              "field3": "ml. 200",
              "field4": "",
              "description": "pam panna da cucina  ml. 200",
              "grammage": 200,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.26927784577724,
                "left": 42.0062219502244,
                "width": 18.884536923704626,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000286_pam_panna_cucina_m200_1532683073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0c10ilo_D7m0Cc9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134845",
              "field1": "gallo",
              "field2": "riso blond risotti",
              "field3": "kg. 1",
              "field4": "",
              "description": "gallo riso blond risotti kg. 1",
              "grammage": 0,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 21.78702570379437,
                "left": 42.0062219502244,
                "width": 18.884536923704626,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/GALLO_BlondRisotti-1Kg_febbraio_2013_1485508114_1519808674.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_FzQ8aaO_uBiQWfs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162571",
              "field1": "barilla emiliane",
              "field2": "cannelloni all'uovo",
              "field3": "gr. 250",
              "field4": "",
              "description": "barilla emiliane cannelloni all'uovo gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 42.0062219502244,
                "width": 18.884536923704626,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Cannelloni_250g_sx_1576487109_1576510958.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_U7s50fg_aOI1MiR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134036",
              "field1": "barilla emiliane",
              "field2": "nidi all'uovo",
              "field3": "gr. 250",
              "field4": "",
              "description": "barilla emiliane nidi all'uovo gr. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tagliatelle",
                "Fettucine",
                "Pappardelle"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 3.182374541003672,
                "left": 60.89075887392903,
                "width": 18.512851897184802,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Fettuccine_250g_sx_1575304127_1581344447.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Pappardelle_ricce_250g_sx_1575304126_1581344448.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_t3KroT0_wUDJ00r.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164178",
              "field1": "granoro",
              "field2": "lasagne all'uovo",
              "field3": "gr. 500",
              "field4": "",
              "description": "granoro lasagne all'uovo gr. 500",
              "grammage": 500,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 21.78702570379437,
                "left": 61.28580171358631,
                "width": 18.512851897184802,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/15404_1492176987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_XMi9fvN_6fcgW3d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134026",
              "field1": "chef ",
              "field2": "besciamella ",
              "field3": "ml. 200",
              "field4": "",
              "description": "chef  besciamella  ml. 200",
              "grammage": 200,
              "price": "0.75",
              "price_label": "€ 0,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.1468788249694,
                "left": 61.28580171358631,
                "width": 18.512851897184802,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/200__BESCIAMELLA_1486633120_1504514031.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_njYQCop_FlY0fNI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130212",
              "field1": "saclà",
              "field2": "acetelli",
              "field3": "gr. 560",
              "field4": "-giardiniera -insalatina",
              "description": "saclà acetelli gr. 560 -giardiniera -insalatina",
              "grammage": 560,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Giardineria",
                "Insalatina"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 61.28580171358631,
                "width": 18.512851897184802,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/sacla_acetelli_insalatina_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/M_acetelli_giardiniera_1593020356_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ncbYqkl_5jHh6JP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "168481",
              "field1": "brioschi",
              "field2": "effervescente",
              "field3": "vaso gr. 250",
              "field4": "",
              "description": "brioschi effervescente vaso gr. 250",
              "grammage": 250,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 61.28580171358631,
                "width": 18.512851897184802,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Brioschi_Effervescente_250_gr_1543593021.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_avhn6H4_iXFXqvF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130222",
              "field1": "pata",
              "field2": "patatina",
              "field3": "classica",
              "field4": "gr. 500 ",
              "description": "pata patatina classica gr. 500 ",
              "grammage": 500,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 83.47613219094248,
                "left": 79.79865361077113,
                "width": 18.489494084047347,
                "height": 13.219094247246023
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Pata_trasparente_500g._classica_1443450502.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mwHfEeF_DDQhlb7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137425",
              "field1": "salati preziosi",
              "field2": "patatine",
              "field3": "gr. 120",
              "field4": "-paprika -barbecue -grigliata",
              "description": "salati preziosi patatine gr. 120 -paprika -barbecue -grigliata",
              "grammage": 120,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Paprika",
                "Barbecue",
                "Grigliata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 70.13463892288861,
                "left": 79.79865361077113,
                "width": 18.489494084047347,
                "height": 13.341493268053858
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Salati_Preziosi_Chips_barbecue_SP_1481738144_1533307434.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Salati_Preziosi_Chips_paprika_SP_1481738145_1533307434.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/salati_preziosi_Chips_grigliata_1495558568_1529923999_1546875333.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_OgOqz52_s1VKKHa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "217341",
              "field1": "patatine",
              "field2": "pringles",
              "field3": "-original -paprika -ketchup",
              "field4": "gr. 175",
              "description": "patatine pringles -original -paprika -ketchup gr. 175",
              "grammage": 175,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "Paprika",
                "Ketchup"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 56.9155446756426,
                "left": 79.79865361077113,
                "width": 18.489494084047347,
                "height": 13.219094247246023
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FLAT_HPR_1589464557_1590569567_1590734737_1592318342_1593790323_1595265536.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FLAT_ORG_1589464560_1590569568_1590734738_1592318343_1593790324_1595265537.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8nhOOEE_4X1rjq3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "207599",
              "field1": "pata",
              "field2": "salatini sfizzy",
              "field3": "sacco kg. 1",
              "field4": "",
              "description": "pata salatini sfizzy sacco kg. 1",
              "grammage": 0,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 43.20685434516524,
                "left": 80.32537739698083,
                "width": 18.489494084047347,
                "height": 13.219094247246023
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8002183015644_PataCocktail1kg_1583520073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_B65U8so_Vk6oekF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165924",
              "field1": "tuc ",
              "field2": "crisp",
              "field3": "gr. 100",
              "field4": "-original -erbe mediterranee -paprika -pepe nero e sale",
              "description": "tuc  crisp gr. 100 -original -erbe mediterranee -paprika -pepe nero e sale",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "Erbe mediterranee",
                "Paprika",
                "Pepe nero e sale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 29.987760097919217,
                "left": 80.32537739698083,
                "width": 18.489494084047347,
                "height": 13.219094247246023
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TUC_CRIPS_erbe_mediterranee_1473240871_1504628582_1542027770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TUC_CRIPS_paprika_1473240848_1504628582_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TUC_CRIPS_sale_marino_1473240884_1504628583_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_TqRaNRG_URnSPbd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131647",
              "field1": "fiore di puglia",
              "field2": "taralli",
              "field3": "gr. 500",
              "field4": "-classico -mediterraneo -finocchio",
              "description": "fiore di puglia taralli gr. 500 -classico -mediterraneo -finocchio",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Mediterraneo",
                "Finocchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 16.52386780905753,
                "left": 80.32537739698083,
                "width": 18.489494084047347,
                "height": 13.463892288861688
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/fiore_di_puglia_Taralli__g500_finocchio__1531124850.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/fiore_di_puglia_Taralli__g500__mediterraneo__1531124848_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/fiore_di_puglia_Taralli__g500_classici__1531124849_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_1jI8eU6_aQZDgcx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "207597",
              "field1": "movida",
              "field2": "arachidi tostate e salate",
              "field3": "kg. 1",
              "field4": "",
              "description": "movida arachidi tostate e salate kg. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 6.487148102815178,
                "left": 80.06201550387598,
                "width": 18.7528559771522,
                "height": 10.03671970624235
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/movida_arachidi_busta_1_kg_1491040051_1583512661.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Ar4otIU_vGtPtvS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 19,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0019_ACRrxFg.jpg",
          "products": [
            {
              "item_id": "131531",
              "field1": "ninfole",
              "field2": "caffè corallo",
              "field3": "gr. 250 x 4",
              "field4": "",
              "description": "ninfole caffè corallo gr. 250 x 4",
              "grammage": 0,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 11.260709914320685,
                "left": 1.7118523051815586,
                "width": 47.59098327213385,
                "height": 29.253365973072214
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/caffe_corallo_x4_1563791283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_F7prYAw_lBB2yVh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134641",
              "field1": "bauli",
              "field2": "croissant farciti x 6",
              "field3": "gr. 300",
              "field4": "-cioccolato -crema -ciliegia -5 cereali latte",
              "description": "bauli croissant farciti x 6 gr. 300 -cioccolato -crema -ciliegia -5 cereali latte",
              "grammage": 300,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cioccolato",
                "Crema",
                "Ciliegia",
                "5 cereali latte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 49.248674010607914,
                "width": 23.493370053039605,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Croissant_Cioccolato_6pz_H_1580402014_1581099549_1581336137.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Croissant_Ciliegia_6pz_H_1582556601_1582898939_1585899220_1591943739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_MMnifHx_0fWiNh2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "212160",
              "field1": "casalini",
              "field2": "fagottini cioccolato",
              "field3": "x6",
              "field4": "gr. 300",
              "description": "casalini fagottini cioccolato x6 gr. 300",
              "grammage": 300,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 3.5495716034271725,
                "left": 72.74204406364751,
                "width": 22.72664218686248,
                "height": 18.115055079559365
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/secondaria_8003255506039_1588867956.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_5dpqShW_N10knUc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134054",
              "field1": "pam",
              "field2": "plum cake con yogurt",
              "field3": "x 6",
              "field4": "gr. 198",
              "description": "pam plum cake con yogurt x 6 gr. 198",
              "grammage": 198,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 72.74204406364751,
                "width": 22.72664218686248,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3257740_PAM_PLUMCAKE_x_6_gr.198_1532351834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_2kpd3a3_zY7KInT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166865",
              "field1": "mulino bianco ",
              "field2": "nastrine classiche",
              "field3": "x 6 - gr. 240",
              "field4": "",
              "description": "mulino bianco  nastrine classiche x 6 - gr. 240",
              "grammage": 240,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 21.66462668298654,
                "left": 49.38035495716034,
                "width": 23.361689106487173,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Nastrine_6pz_sx_1524497459_1542644399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_hOxfgHR_7ccfiLk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134618",
              "field1": "oro saiwa",
              "field2": "biscotti classico",
              "field3": "kg. 1",
              "field4": "",
              "description": "oro saiwa biscotti classico kg. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 72.95124439004489,
                "width": 23.361689106487173,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/oro_saiwa_1kg_1532680441.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Iq9lEeV_29OhjA7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137380",
              "field1": "mulino bianco  ",
              "field2": "biscotti classici",
              "field3": "-tarallucci -macine -galletti gr. 350",
              "field4": "-spicchi di sole gr. 400",
              "description": "mulino bianco   biscotti classici -tarallucci -macine -galletti gr. 350 -spicchi di sole gr. 400",
              "grammage": null,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tarallucci",
                "Macine",
                "Galletti",
                "Spicchi di sole"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 49.171154630762985,
                "width": 23.253365973072192,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Macine_350g_sx2_1506522793.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Galletti_350g_sx2_1506522795.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Spicchi_di_sole_400g_sx2_1506522796.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_tS9nDHV_qshEceV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134063",
              "field1": "vicenzovo",
              "field2": "savoiardi",
              "field3": "sacco gr. 400",
              "field4": "",
              "description": "vicenzovo savoiardi sacco gr. 400",
              "grammage": 400,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 24.887698898408814,
                "width": 24.283455732354167,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Vicenzovo_Savoiardi_400g_1464009468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wZMPW1d_nKGcIhB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139521",
              "field1": "di leo",
              "field2": "biscotti caserecci ",
              "field3": "gr. 600/700",
              "field4": "vari tipi",
              "description": "di leo biscotti caserecci  gr. 600/700 vari tipi",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 1.7118523051815586,
                "width": 23.175846593227252,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/di_leo_paesani_integrali_500_gr_1576518705_1579531942_1586269341_1594284861.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/di_leo_lune_integrali_500_gr_1576518705_1579531941_1586269341_1594284862.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6VTv7Gc_gTVwm32.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140848",
              "field1": "mulino bianco",
              "field2": "fette biscottate dorate",
              "field3": "x 72",
              "field4": "gr. 630",
              "description": "mulino bianco fette biscottate dorate x 72 gr. 630",
              "grammage": 630,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 1.7118523051815586,
                "width": 18.698694410444716,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Fette_dorate_72_sx_1562581825_1564133614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_8cDSEnn_CzB4ne6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140850",
              "field1": "fitness",
              "field2": "cereali integrali",
              "field3": "-fruits gr. 325 -chocolate gr. 375",
              "field4": "-dark chocolate gr. 375",
              "description": "fitness cereali integrali -fruits gr. 325 -chocolate gr. 375 -dark chocolate gr. 375",
              "grammage": 0,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fruits",
                "Chocolate",
                "Dark chocolate"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 20.410546715626275,
                "width": 18.96205630354957,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/32513_1497627026_1575387242.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/nestle_fitness_cioccolato_375g_1495725156_1605721135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/nestle_fitness_cioccolato_fondente_375g_1495725157_1605721135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iObzxeQ_VGCBUmb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179446",
              "field1": "pam",
              "field2": "cereali anellini al miele gr. 375",
              "field3": "",
              "field4": "",
              "description": "pam cereali anellini al miele gr. 375",
              "grammage": 375,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 39.37260301917585,
                "width": 18.56701346389229,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/pam_anellini_al_miele_375_gr_1597830690.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ypLQHl0_WhfmbvH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131545",
              "field1": "zuegg ",
              "field2": "confetture 100% da frutta",
              "field3": "gr. 250",
              "field4": "vari gusti",
              "description": "zuegg  confetture 100% da frutta gr. 250 vari gusti",
              "grammage": 250,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Ciliegia",
                "Fragola",
                "Frutti di bosco"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 57.93961648306813,
                "width": 18.830375356997145,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Zuegg_Ciliegie_1467987669_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Zuegg_Fragole_1467987661_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Zuegg_Frutti-bosco_1467987654_1535995532.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_pl8oiKK_QkJxHeB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164173",
              "field1": "butter cookies",
              "field2": "biscotti al burro",
              "field3": "gr. 454",
              "field4": "",
              "description": "butter cookies biscotti al burro gr. 454",
              "grammage": 454,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 76.76999184006527,
                "width": 18.830375356997145,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/biscotti_al_burro_lattta_g454_1541173878.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sgzHkGu_3C4vSYQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170704",
              "field1": "rigoni",
              "field2": "nocciolata bio classica",
              "field3": "gr. 270",
              "field4": "",
              "description": "rigoni nocciolata bio classica gr. 270",
              "grammage": 270,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 76.76999184006527,
                "width": 18.830375356997145,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/484801_ITA_Nocc_classica_2020_rev1-e1592912812381_1599062950_1600183_vOApStc.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_eqoYbqt_LGOcqWZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165937",
              "field1": "ambrosoli",
              "field2": "miele",
              "field3": "gr. 500",
              "field4": "",
              "description": "ambrosoli miele gr. 500",
              "grammage": 500,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.7233782129743,
                "left": 58.46634026927785,
                "width": 18.303651570787437,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ambrosoli_miele_1543316770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_YbXuUJy_bQiJxwg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139537",
              "field1": "pam  ",
              "field2": "wafer",
              "field3": "gr. 175",
              "field4": "crema -latte -cacao -nocciola",
              "description": "pam   wafer gr. 175 crema -latte -cacao -nocciola",
              "grammage": 175,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Crema",
                "Latte",
                "Cacao",
                "Nocciola"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 77.84577723378213,
                "left": 39.24092207262342,
                "width": 18.698694410444716,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000314_pam_wafer_g175_cacao_1561458671.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000315_pam_wafer_g175_nocciola_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000316_pam_wafer_g175_latte_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_lw6X5CK_b6rwJ4G.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166886",
              "field1": "fida ",
              "field2": "caramelle bonelle ",
              "field3": "vari gusti",
              "field4": "busta gr. 150/175",
              "description": "fida  caramelle bonelle  vari gusti busta gr. 150/175",
              "grammage": null,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 20.410546715626275,
                "width": 18.830375356997145,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FIDA_CARAMELLE_BUSTA_GR.200_gruppo_1573481687.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_NDgsMPi_7GqiofS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141904",
              "field1": "novi",
              "field2": "tavoletta di cioccolato le specialità",
              "field3": "vari gusti gr. 100 ",
              "field4": "",
              "description": "novi tavoletta di cioccolato le specialità vari gusti gr. 100 ",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Noisette",
                "Bianco",
                "FondenteNero"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 1.8435332517339862,
                "width": 18.56701346389229,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/tavoletta-fondentenero_1576505514.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/noisette_1576505514.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/novi_bianco_1576505515.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_h3bd4tj_7dcpJoJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 20,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0020_5sCa4be.jpg",
          "products": [
            {
              "item_id": "133979",
              "field1": "valfrutta",
              "field2": "succhi",
              "field3": "ml. 200 x 6",
              "field4": "-pera -pesca -albicocca",
              "description": "valfrutta succhi ml. 200 x 6 -pera -pesca -albicocca",
              "grammage": 1200,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pera",
                "Pesca",
                "Albicocca"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 3.0599755201958385,
                "left": 3.8187474500204,
                "width": 23.175846593227252,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VF-cluster-albicoccaX6_10008_1548079549.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VF-cluster-peraX6_10007_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/VF-cluster-pescaX6_10009_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_x1wA7HP_suOi5lO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140942",
              "field1": "santal",
              "field2": "succhi brik",
              "field3": "lt. 1",
              "field4": "-classici -plus vari gusti",
              "description": "santal succhi brik lt. 1 -classici -plus vari gusti",
              "grammage": 0,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classici",
                "Plus",
                "Vari gusti"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 3.0599755201958385,
                "left": 27.78467972256222,
                "width": 23.834251325989396,
                "height": 18.482252141982865
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/santal_plus_pesca_mango_1587546032.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/santal_succo_pesca_1587546033.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/santal_succo_plus_ananas_cocco_1587546034.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ErkA80q_Zv7ne2F.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134075",
              "field1": "trevalli ",
              "field2": "latte uht edge",
              "field3": "parzialmente scremato 100% italiano",
              "field4": "lt. 1",
              "description": "trevalli  latte uht edge parzialmente scremato 100% italiano lt. 1",
              "grammage": null,
              "price": "0.65",
              "price_label": "€ 0,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 27.78467972256222,
                "width": 23.834251325989396,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TRE_VALLI_Latte_100_Italiano_PS__Edge_lt.1_1532342298.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_zlo0iSy_THtUjj1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137389",
              "field1": "céréal",
              "field2": "soia drink calcio",
              "field3": "lt. 1",
              "field4": "",
              "description": "céréal soia drink calcio lt. 1",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 4.082109343125255,
                "width": 23.702570379436963,
                "height": 18.9718482252142
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/CEREAL_SOIA_DRINK_CALCIO_1__LT._1505837035_1565691205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0lBmzxE_3amXv85.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134630",
              "field1": "parmalat ",
              "field2": "latte del benessere uht",
              "field3": "lt. 1",
              "field4": "-calcium plus -omega 3",
              "description": "parmalat  latte del benessere uht lt. 1 -calcium plus -omega 3",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Calcium plus",
                "Omega 3"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 4.082109343125255,
                "width": 23.439208486332106,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/1038121_LATTE_UHT_PARMALAT_1L_CALCIUM_PLUS_1523439517.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/1038126_LATTE_UHT_PARMALAT_1L_OMEGA3_1523439521.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_nGIfszl_eCU8BbY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215557",
              "field1": "zymil",
              "field2": "benefit latte uht",
              "field3": "lt. 1",
              "field4": "-calcio -fibre -vitamina B12 e D",
              "description": "zymil benefit latte uht lt. 1 -calcio -fibre -vitamina B12 e D",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Calcio",
                "Fibr",
                "Vitamina B12 e D"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 27.52131782945736,
                "width": 24.36097511219911,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8002580003671_1587740610_1592207096_1592840883_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/principale_8002580003695_1587740611_1592207097_1592840884_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ZYMIL_BENEFIT_VITAMINE_FRONT_1599240553.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ZCChtJq_tLz1hw9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "235658",
              "field1": "cuki",
              "field2": "carta per fritti",
              "field3": "20 fogli",
              "field4": "32x33",
              "description": "cuki carta per fritti 20 fogli 32x33",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 51.882292941656466,
                "width": 23.57088943288453,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8003980210010_1564130470_1600677091_1603294038.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Rxk6vGj_xZCa3E2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137471",
              "field1": "pam",
              "field2": "alluminio",
              "field3": "16 metri",
              "field4": "",
              "description": "pam alluminio 16 metri",
              "grammage": 0,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 75.453182374541,
                "width": 22.780803753569973,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000108_PAM_ALLUMINIO_16_METRI_1533288333.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_BEJY61y_NpeBECG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131607",
              "field1": "cuki",
              "field2": "2 vaschette alluminio da 12 porzioni",
              "field3": "",
              "field4": "",
              "description": "cuki 2 vaschette alluminio da 12 porzioni",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 75.453182374541,
                "width": 22.780803753569973,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Cuki_Vaschetta_Senza_Coperchio_12_porzioni_1504099229.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_37q1P1u_SE6KEMy.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134851",
              "field1": "pam ",
              "field2": "pellicola trasparente ",
              "field3": "50 metri",
              "field4": "",
              "description": "pam  pellicola trasparente  50 metri",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 52.0139738882089,
                "width": 23.439208486332106,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4000107_pam_pellicola_trasparente_50mt_1532683313.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mSw9vJF_olQfwF7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180759",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "capsule x 16",
              "field4": "vari tipi",
              "description": "nescafè dolce gusto capsule x 16 vari tipi",
              "grammage": null,
              "price": "4.59",
              "price_label": "€ 4,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Espresso Napoli",
                "Espresso Roma"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 27.389636882904938,
                "width": 24.624337005303964,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NESCAFE_DOLCE_GUSTO_NAPOLI_1559122141.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NESCAFE_DOLCE_GUSTO_ROMA_1559122142.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_nsEJvhH_QmLCZ5a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130252",
              "field1": "lavazza",
              "field2": "caffè crema e gusto espresso",
              "field3": "gr. 250",
              "field4": "",
              "description": "lavazza caffè crema e gusto espresso gr. 250",
              "grammage": 250,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 3.687066503467976,
                "width": 23.702570379436963,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Lavazza_espresso_classico_250_gr_1504802586.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_G1IBVHg_BeUa9iz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130255",
              "field1": "lavazza",
              "field2": "caffè crema e gusto classico",
              "field3": "gr. 250 x 3",
              "field4": "",
              "description": "lavazza caffè crema e gusto classico gr. 250 x 3",
              "grammage": 750,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 3.687066503467976,
                "width": 23.702570379436963,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Lavazza_crema_e_gusto_classico_3_x_250_1521196954.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_BzMOvlK_j9UlTlA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134074",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "macchina con 32 caps omaggio ",
              "field4": "",
              "description": "nescafè dolce gusto macchina con 32 caps omaggio ",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Piccoli elettrodomestici",
              "subcategory": "Preparazione cibo",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 27.389636882904938,
                "width": 24.492656058751535,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/NESCAFE_MACCHINA_DOLCE_GUSTO_KRUBS_1552665915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_rE1aeYH_9ugacTe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139582",
              "field1": "cuki vaschette in alluminio",
              "field2": "•2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI",
              "field3": "•3 VASCHETTE ALLUMINIO DA 5 PORZIONi",
              "field4": "•4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "description": "cuki vaschette in alluminio •2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI •3 VASCHETTE ALLUMINIO DA 5 PORZIONi •4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 51.882292941656466,
                "width": 46.61505507955937,
                "height": 19.094247246022032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Vaschetta_CUKI_RS98_-_8_porzioni_Giugiaro_x2_1444907247.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_wRgvoPz_GOxB2Lv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "169950",
              "field1": "tenderly",
              "field2": "tovaglioli jumbo formato scorta",
              "field3": "x 330",
              "field4": "",
              "description": "tenderly tovaglioli jumbo formato scorta x 330",
              "grammage": 0,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 11.015911872705017,
                "left": 52.0139738882089,
                "width": 23.439208486332113,
                "height": 29.987760097919217
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Tenderly_tovaglioli_Jumbo_1545072318.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gQiIzwF_Z7UgSJq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131596",
              "field1": "aristea ",
              "field2": "piatti rigidi",
              "field3": "kg. 1 ",
              "field4": "-fondi -piani ",
              "description": "aristea  piatti rigidi kg. 1  -fondi -piani ",
              "grammage": 0,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fondi",
                "Piani"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 11.015911872705017,
                "left": 75.453182374541,
                "width": 23.09832721338229,
                "height": 29.987760097919217
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Aristea_Piatti_Extra-Rigidi_Piani_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Aristea_Piatti_Extra-Rigidi_Fondo_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GImWsYO_XCgeb3U.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 21,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0021_u2EYgb1.jpg",
          "products": [
            {
              "item_id": "168477",
              "field1": "foxy",
              "field2": "mega asciugatutto",
              "field3": "2 maxi rotoli",
              "field4": "",
              "description": "foxy mega asciugatutto 2 maxi rotoli",
              "grammage": null,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Extra",
              "blueprint": {
                "top": 3.1823745410036706,
                "left": 0.0,
                "width": 24.415136678906567,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FXI237006BX_Foxy_Carta_cucina_Mega_2_rotoli_decorato_2_veli___PCR30__NiW4oHi.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jHqoTXt_yJYF7Or.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134113",
              "field1": "regina",
              "field2": "5stelle tovaglioli decorati 38x38",
              "field3": "2 veli",
              "field4": "x 46 ",
              "description": "regina 5stelle tovaglioli decorati 38x38 2 veli x 46 ",
              "grammage": 0,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 21.5422276621787,
                "left": 0.0,
                "width": 24.415136678906567,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Tov_5STELLE_azzurro_1548235488_1570810490_1572946864_1590141947.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_hnRzN9P_s1LjVJi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165928",
              "field1": "tenderly",
              "field2": "duo prestige tovaglioli rossi 38x38",
              "field3": "2 veli x 30",
              "field4": "",
              "description": "tenderly duo prestige tovaglioli rossi 38x38 2 veli x 30",
              "grammage": 0,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.391676866585065,
                "left": 0.0,
                "width": 24.415136678906567,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/tenderly_duo_Prestige_rosso_1542047453.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JQWqL1l_Q8gtbrK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131598",
              "field1": "aristea ",
              "field2": "bicchieri bianchi",
              "field3": "cc. 200",
              "field4": "x 100",
              "description": "aristea  bicchieri bianchi cc. 200 x 100",
              "grammage": 0,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 59.118727050183594,
                "left": 0.0,
                "width": 24.415136678906567,
                "height": 37.45410036719706
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Aristea_100_bicchieri_2_colonne_200_cc.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_YFNaOC6_ae1stho.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131705",
              "field1": "coca cola",
              "field2": "bipack",
              "field3": "lt. 1,35 x 2",
              "field4": "-classica -zero",
              "description": "coca cola bipack lt. 1,35 x 2 -classica -zero",
              "grammage": 2700,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classica",
                "Zero"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 11.383108935128513,
                "left": 24.887698898408814,
                "width": 47.32762137902896,
                "height": 29.253365973072214
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/1042988_COCA_COLA_ZERO_BIPACK_1_5_1486727334_1492513881_1493282536_1_2PSrEFE.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cocacolax2_1490861689_1492513814_1493282536_1493886339_1522243702.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_yxwTqtC_t3LZKf4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131718",
              "field1": "levissima",
              "field2": "acqua naturale",
              "field3": "lt. 2  ",
              "field4": "cassa x 6",
              "description": "levissima acqua naturale lt. 2   cassa x 6",
              "grammage": 12000,
              "price": "2.40",
              "price_label": "€ 2,40",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 3.059975520195832,
                "left": 72.55620155038761,
                "width": 23.09832721338229,
                "height": 37.45410036719706
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/levissima_naturale_2_lt_x_6_1468226886.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_CT9wEsw_zUz3sbe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133983",
              "field1": "raffo",
              "field2": "birra ",
              "field3": "cl. 33 x 3",
              "field4": "",
              "description": "raffo birra  cl. 33 x 3",
              "grammage": 990,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 40.51407588739289,
                "left": 72.55620155038761,
                "width": 23.09832721338229,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/5447_1529318883_1543603380_1595326939.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_RSNGUbG_56Ietak.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133982",
              "field1": "san pellegrino ",
              "field2": "bibite",
              "field3": "lt. 1,25",
              "field4": "-aranciata classica -chinò -cocktail",
              "description": "san pellegrino  bibite lt. 1,25 -aranciata classica -chinò -cocktail",
              "grammage": 1250,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Aranciata classica",
                "Chinò",
                "Cocktail"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 40.51407588739289,
                "left": 49.03947368421052,
                "width": 23.516727866177074,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/San_Pellegrino_Chino_Lt_15_1443514571_1446733390.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/San_Pellegrino_aranciata_lt_125_1446216586_1467368343.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/san_pellegrino_cocktail_1450166834_1467901906_1512493856_1535451695.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mcwZyUw_lvCuaSL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137460",
              "field1": "gaudianello",
              "field2": "acqua ",
              "field3": "lt. 1,5 cassa x 6",
              "field4": "-effervescente naturale -frizzante",
              "description": "gaudianello acqua  lt. 1,5 cassa x 6 -effervescente naturale -frizzante",
              "grammage": 9000,
              "price": "1.50",
              "price_label": "€ 1,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Effervescente naturale",
                "Frizzante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 40.51407588739289,
                "left": 24.887698898408814,
                "width": 24.15177478580171,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Gaudianello_Fardello_x_6_1470387896_1529512871.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_9orvBkm_TxsbsAw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137007",
              "field1": "dreher",
              "field2": "birra",
              "field3": "cl. 33",
              "field4": "la cassa x 12",
              "description": "dreher birra cl. 33 la cassa x 12",
              "grammage": 3960,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 59.24112607099142,
                "left": 24.887698898408814,
                "width": 26.917074663402687,
                "height": 37.086903304773564
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/valigetta_MB_12x33_2020_1591006533.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iZdcznj_pm3VXpf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130173",
              "field1": "heineken",
              "field2": "Birra",
              "field3": "cl. 66",
              "field4": "",
              "description": "heineken Birra cl. 66",
              "grammage": 660,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 59.24112607099142,
                "left": 51.80477356181151,
                "width": 20.883108935128526,
                "height": 37.086903304773564
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/heineken_birra_66_cl.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_S5TfiPw_2LA3QqR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131700",
              "field1": "ichnusa",
              "field2": "birra non filtrata",
              "field3": "cl. 50",
              "field4": "",
              "description": "ichnusa birra non filtrata cl. 50",
              "grammage": 500,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 59.24112607099142,
                "left": 72.68788249694002,
                "width": 23.361689106487145,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ichnusa_birra_non_filtrata_1507535387_1526923226.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_FXg9b4b_5FFozVP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179453",
              "field1": "tennent's",
              "field2": "super birra",
              "field3": "bottiglia cl. 35,5",
              "field4": "",
              "description": "tennent's super birra bottiglia cl. 35,5",
              "grammage": 355,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 77.96817625458996,
                "left": 72.68788249694002,
                "width": 23.361689106487145,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/494912_1554309343_1557473308_1557827706.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mQFMn1N_EcLE5yH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 22,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0022_9j0rrDl.jpg",
          "products": [
            {
              "item_id": "239430",
              "field1": "svelto",
              "field2": "piatti ",
              "field3": "-antibatterico -limone verde -aceto -zenzero e limone",
              "field4": "lt. 1",
              "description": "svelto piatti  -antibatterico -limone verde -aceto -zenzero e limone lt. 1",
              "grammage": 0,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Antibatterico",
                "Limone verde",
                "Aceto",
                "Zenzero e limone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 10.77111383108935,
                "left": 4.345471236230111,
                "width": 37.05650754793961,
                "height": 29.742962056303547
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Svelto_LIMONE_VERDE_1496918743_1499071488_1512486297_1542632483_1605716460.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/svelto_ACETO_1l_1496918742_1499071488_1512486297_1532967204_15427153_PXwH23F.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_zXP0sjT_JDPko9P.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "167090",
              "field1": "ace",
              "field2": "candeggina",
              "field3": "lt. 5",
              "field4": "",
              "description": "ace candeggina lt. 5",
              "grammage": 5000,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 4.345471236230111,
                "width": 18.75285597715218,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ace-classica-5-lt_1558948335.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_sJ5CSkX_sP8fFwC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "211400",
              "field1": "vernel",
              "field2": "ammorbidente concentrato",
              "field3": "28 lavaggi ml. 700",
              "field4": "vari tipi",
              "description": "vernel ammorbidente concentrato 28 lavaggi ml. 700 vari tipi",
              "grammage": 700,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 40.5140758873929,
                "left": 23.09832721338229,
                "width": 18.512851897184827,
                "height": 18.72705018359853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/61934_VernelBluOxygen_1565252093_1566381930_1569256625_1582543571_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/61935_VernelLavanda_1565252095_1566381930_1569256626_1582543572_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_vW6y3gT_gqoXT3u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206606",
              "field1": "ace",
              "field2": "sgrassatore senza candeggina",
              "field3": "spray ml. 500",
              "field4": "-universale -cucina -igienizzante",
              "description": "ace sgrassatore senza candeggina spray ml. 500 -universale -cucina -igienizzante",
              "grammage": 500,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Superfici",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 23.09832721338229,
                "width": 18.512851897184827,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ace-spray-sgrassatore-universale-senza-candeggina-fresco-profumo-500_e3odq9U.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ACE_SPRAY_SGRASSATORE_CUCINA_500ML_1580406347_1582301398.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ACE_SPRAY_SGRASSATORE_IGIENIZZANTE_500ML_1580406349_1582301399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_BbICPu9_zBkMHMN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "183607",
              "field1": "pam",
              "field2": "lavatrice liquido 30 lavaggi",
              "field3": "lt. 2",
              "field4": "-aloe vera -fresco profumo",
              "description": "pam lavatrice liquido 30 lavaggi lt. 2 -aloe vera -fresco profumo",
              "grammage": 2000,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Aloe vera",
                "Fresco profumo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 4.082109343125259,
                "width": 19.016217870257034,
                "height": 18.2374541003672
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260429_PAM_LAVATR.LIQ.30lav.ALOE_VERA_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260430_PAM_LAVATR.LIQ.30lav.FRESCO_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_iZrmXCZ_RHOryNz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165949",
              "field1": "duracell",
              "field2": "plus power",
              "field3": "x 4",
              "field4": "-stilo -ministilo",
              "description": "duracell plus power x 4 -stilo -ministilo",
              "grammage": null,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Stilo",
                "Ministilo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 4.082109343125259,
                "width": 19.016217870257034,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/duracell_1543317061.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_QGMcYy0_VXnigbR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165933",
              "field1": "linea fresh",
              "field2": "candele profumate",
              "field3": "gr. 120",
              "field4": "assortite",
              "description": "linea fresh candele profumate gr. 120 assortite",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 77.47858017135863,
                "left": 23.09832721338229,
                "width": 18.381170950632402,
                "height": 19.3390452876377
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/linea_fresh_Candela_Profumata_1542047415.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_t6AUwWJ_wzFXRzX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132571",
              "field1": "tenderly",
              "field2": "carta igienica kilometrica",
              "field3": "x 12 maxi rotoli",
              "field4": "",
              "description": "tenderly carta igienica kilometrica x 12 maxi rotoli",
              "grammage": null,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 11.015911872705017,
                "left": 42.718788249694,
                "width": 36.42146062831498,
                "height": 29.37576499388005
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/TENDERLY_CARTA_IG.KILOMETR.x12_1532093467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_tJ8HNC0_j5TEqWi.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131523",
              "field1": "bulky soft",
              "field2": "carta igienica infinita",
              "field3": "2 veli",
              "field4": "x 4 maxi rotoli",
              "description": "bulky soft carta igienica infinita 2 veli x 4 maxi rotoli",
              "grammage": 0,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Person",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 3.304773561811504,
                "left": 79.53529171766625,
                "width": 18.22613219094247,
                "height": 18.48225214198287
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Bulky_Soft_carta_ig.INFINITA_2v.x4_maxi_rotoli_1531125469.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Bz1OAOX_z1HY2bR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134875",
              "field1": "pam arkalia ",
              "field2": "maxi dischetti struccanti ",
              "field3": "x 50",
              "field4": "",
              "description": "pam arkalia  maxi dischetti struccanti  x 50",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Viso",
              "blueprint": {
                "top": 21.787025703794374,
                "left": 79.53529171766625,
                "width": 18.22613219094247,
                "height": 18.84944920440636
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PAM_ARKALIA_MAXI_DISCHETTI_STRUCCANTI_X_50_1535449256.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aCKpzZK_S3HAQSm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239431",
              "field1": "nivea",
              "field2": "bagno creme",
              "field3": "-care -smooth -soft",
              "field4": "ml. 650",
              "description": "nivea bagno creme -care -smooth -soft ml. 650",
              "grammage": 650,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Care",
                "Smooth",
                "Soft"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 79.53529171766625,
                "width": 18.22613219094247,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/80968_22922_1605716634.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/80969_22918_1605716635.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_WM6QIw4_u6GlKFY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137436",
              "field1": "mil mil",
              "field2": "sapone liquido busta ",
              "field3": "lt. 2 ",
              "field4": "-morbidezza naturale -cocco e vaniglia",
              "description": "mil mil sapone liquido busta  lt. 2  -morbidezza naturale -cocco e vaniglia",
              "grammage": 2000,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Morbidezza naturale",
                "Cocco e vaniglia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 61.15412076703387,
                "width": 18.381170950632402,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mil_mil_sapone_liquido_ricarica_classico_cocco_2_lt_1506332984_1506411554.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_eZIGK3V_9sysCiI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137439",
              "field1": "pam",
              "field2": "arkalia sapone",
              "field3": "ml. 300",
              "field4": "-argan -latte e miele",
              "description": "pam arkalia sapone ml. 300 -argan -latte e miele",
              "grammage": 300,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Argan",
                "Latte e miele"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 40.63647490820074,
                "left": 42.0062219502244,
                "width": 19.147898816809462,
                "height": 18.6046511627907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PAM_ARKALIA_SAPONE_M300_tutti_1533307340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_IfCCDwt_8HuSQ4D.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "186597",
              "field1": "dermogella",
              "field2": "-intimo ml. 250",
              "field3": "-intima lenitiva ml. 200",
              "field4": "-intima attiva ml. 200",
              "description": "dermogella -intimo ml. 250 -intima lenitiva ml. 200 -intima attiva ml. 200",
              "grammage": 0,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Intimo",
                "Intimo lenitiva",
                "Intimo attiva"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Intima",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 42.0062219502244,
                "width": 19.147898816809462,
                "height": 18.35985312117503
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260763_1564738467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260768_1564738467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3260769_1564738468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_RSGRHUZ_6ioUU8g.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162589",
              "field1": "dove",
              "field2": "deo",
              "field3": "spray vari tipi ml. 150",
              "field4": "",
              "description": "dove deo spray vari tipi ml. 150",
              "grammage": null,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "Go Fresh"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 60.75907792737658,
                "width": 18.249490004079973,
                "height": 18.359853121175032
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Dove_deodorante_original_1530607792_1539339984.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/Dove_deo_spray_ml.150_Mela_1573487542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Be9bZfI_EHaXuQp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206631",
              "field1": "antica erboristeria",
              "field2": "shampoo ",
              "field3": "-classico -2in1",
              "field4": "vari trattamenti ml. 225/250",
              "description": "antica erboristeria shampoo  -classico -2in1 vari trattamenti ml. 225/250",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "2 in 1"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Capelli",
              "blueprint": {
                "top": 59.241126070991434,
                "left": 79.40361077111385,
                "width": 18.75285597715218,
                "height": 18.35985312117503
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_CAMOMILLA_1582305798_1582827538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_ORTICA_1582305797_1582827539.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/antica_erboristeria_shampo_e_balsamo_bacche_acai_1582556654_1588926583.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/antica_erboristeria_shampo_e_balsamo_frutto_passione_1582556655_1588926584.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_JONLMp5_1Nh47AZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134042",
              "field1": "mellin",
              "field2": "crema ",
              "field3": "gr. 200",
              "field4": "-di riso -mais e tapioca -semolino",
              "description": "mellin crema  gr. 200 -di riso -mais e tapioca -semolino",
              "grammage": 200,
              "price": "2.10",
              "price_label": "€ 2,10",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Di riso",
                "Mais e tapioca",
                "Semolino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 79.40361077111385,
                "width": 18.75285597715218,
                "height": 18.84944920440637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mellin_Crema_di_Riso_g_200_1497878654.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/mellin_semolino_g_200_1497878655.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_KhIgSEy_ykiXsvv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206623",
              "field1": "plasmon",
              "field2": "merenda",
              "field3": "gr. 120 x 2",
              "field4": "-pera e yogurt -banana e yogurt",
              "description": "plasmon merenda gr. 120 x 2 -pera e yogurt -banana e yogurt",
              "grammage": 240,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pera e yogurt",
                "Banana e yogurt"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 61.15412076703387,
                "width": 18.249490004079973,
                "height": 18.84944920440637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PLASMON-BANANA-E-YOGURT-240G_1582303791.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/PLASMON-YOGURT-PERA-240G_1582303791.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gQlByQX_rBDMdS6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164144",
              "field1": "colgate",
              "field2": "dentifricio family action",
              "field3": "ml. 75",
              "field4": "",
              "description": "colgate dentifricio family action ml. 75",
              "grammage": 75,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 77.60097919216646,
                "left": 42.0062219502244,
                "width": 19.147898816809462,
                "height": 18.84944920440637
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/FOTO_DENTIFRICIO_FAMILY_ACTION_75_ml_1550239870.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_AoyB4s3_Fy4uvS0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 23,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0023_wqqH2js.jpg",
          "products": [
            {
              "item_id": "239436",
              "field1": "malizia",
              "field2": "confezione regalo animalier",
              "field3": "profumo + crema + collana",
              "field4": "",
              "description": "malizia confezione regalo animalier profumo + crema + collana",
              "grammage": null,
              "price": "5.89",
              "price_label": "€ 5,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 7.833537331701347,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 15.299877600979196
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8003510033201_T5_1606133009.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_FXCBz9h_TcMHmiV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239434",
              "field1": "intesa",
              "field2": "confezione regalo ",
              "field3": "cura viso detergente + aftershave",
              "field4": "",
              "description": "intesa confezione regalo  cura viso detergente + aftershave",
              "grammage": null,
              "price": "8.99",
              "price_label": "€ 8,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Viso",
              "blueprint": {
                "top": 23.133414932680544,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 14.687882496940022
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8003510033164_T5_1606133160.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gJ6yLfV_oWRhbH7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239435",
              "field1": "lol surprise",
              "field2": "confezione regalo dentifricio + spazzolino + bicchiere + pochette",
              "field3": "",
              "field4": "",
              "description": "lol surprise confezione regalo dentifricio + spazzolino + bicchiere + pochette",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 37.821297429620564,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 14.443084455324362
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3264202_1606133126.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_DyobsBR_9QZuyHj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239437",
              "field1": "tesori d'oriente ",
              "field2": "confezione regalo + pochette",
              "field3": "",
              "field4": "",
              "description": "tesori d'oriente  confezione regalo + pochette",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 52.26438188494492,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 14.810281517747855
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8008970049953_T5_1606133038.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_GXxz2Oi_k0Cl5N2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239433",
              "field1": "i provenzali ",
              "field2": "confezione regalo crema viso + occhi",
              "field3": "",
              "field4": "",
              "description": "i provenzali  confezione regalo crema viso + occhi",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Viso",
              "blueprint": {
                "top": 67.07466340269278,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 14.81028151774786
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/8025796009305_T70_1606133072.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_S5S1sNL_0xf0JiV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239432",
              "field1": "clinians",
              "field2": "confezione regalo",
              "field3": "crema viso + micellare",
              "field4": "",
              "description": "clinians confezione regalo crema viso + micellare",
              "grammage": null,
              "price": "14.99",
              "price_label": "€ 14,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Viso",
              "blueprint": {
                "top": 81.88494492044063,
                "left": 1.7118523051815586,
                "width": 23.361689106487145,
                "height": 14.56548347613219
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3264199_1606133102.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_0dTwfWk_OqjI6ym.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239531",
              "field1": "-betoniera trainabile con formine a incastro                                                   ",
              "field2": "-gelateria ice cream pz. 20                                                                      ",
              "field3": "",
              "field4": "",
              "description": "-betoniera trainabile con formine a incastro                                                    -gelateria ice cream pz. 20                                                                      ",
              "grammage": 0,
              "price": "11.90",
              "price_label": "€ 11,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 79.68176254589964,
                "left": 25.20522235822113,
                "width": 41.95206038351694,
                "height": 16.768665850673194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/11.90_GLOBO_BETONIERA_TRAINABILE_CON_FORMINE_A_INCASTRO_1605785974.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/11.90_GLOBO_GELATERIA_ICE_CREAM_20PZ__1605785995.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_gy2h9En_ploS8TX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239532",
              "field1": "star wars spada laser spin action ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "star wars spada laser spin action ",
              "grammage": 0,
              "price": "12.50",
              "price_label": "€ 12,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 79.68176254589964,
                "left": 67.55232558139534,
                "width": 28.102203182374534,
                "height": 16.768665850673194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/12.50_STAR_WARS_SPADA_LASER_SPIN_ACTION__1605786015.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Fn2mOrM_ebbg3lZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239530",
              "field1": "-barbie set arredo ",
              "field2": "-baby gaggia macchina da caffè",
              "field3": "",
              "field4": "",
              "description": "-barbie set arredo  -baby gaggia macchina da caffè",
              "grammage": 0,
              "price": "10.90",
              "price_label": "€ 10,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 60.83231334149328,
                "left": 57.28121175030601,
                "width": 38.37331701346389,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/10.90_BABY_GAGGIA_MACCHINA_DA_CAFFE__1605785915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/10.90_BARBIE_SET_ARREDO__1605785933.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_L97CM7G_K86iO61.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239529",
              "field1": "crayola pasta da modellare set mondo sottomarino ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "crayola pasta da modellare set mondo sottomarino ",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 60.83231334149328,
                "left": 25.600265197878414,
                "width": 31.68094655242758,
                "height": 18.849449204406366
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/9.90_CRAYOLA_PASTA_DA_MODELLARE_SET_MONDO_SOTTOMARINO__1605785895.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_2QslcG5_wSYrqGe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239527",
              "field1": "-3 pony magic friends",
              "field2": "-bambolina con scooter/animali/accessori                             ",
              "field3": "-animale carillon di stoffa cm16.5 try me                                ",
              "field4": "",
              "description": "-3 pony magic friends -bambolina con scooter/animali/accessori                              -animale carillon di stoffa cm16.5 try me                                ",
              "grammage": 0,
              "price": "7.90",
              "price_label": "€ 7,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 44.308445532435755,
                "left": 25.600265197878414,
                "width": 41.82037943696451,
                "height": 16.52386780905753
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7.90_GLOBO_3_PONY_MAGIC_FRIENDS____1605785822.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7.90_GLOBO_ANIMALE_CARILLON_DI_STOFFA_CM16.5_TRY_ME_1605785840.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7.90_GLOBO_BAMBOLINA_CON_SCOOTER-ANIMALI-ACCESSORI__1605785857.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Is0vfc5_IAtJViT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239528",
              "field1": "mattel jurassic world personaggio cm.10 owen raptor trainer ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "mattel jurassic world personaggio cm.10 owen raptor trainer ",
              "grammage": 0,
              "price": "9.50",
              "price_label": "€ 9,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 44.308445532435755,
                "left": 67.42064463484293,
                "width": 28.365565075479388,
                "height": 15.911872705018359
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/9.50_MATTEL_JURASSIC_WORLD_PERSONAGGIO_CM.10_OWEN_RAPTOR_TRAINER__1605785878.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6a30BlX_zloZmu0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239526",
              "field1": "auto corsa racing car full function 27mhz                                                     ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "auto corsa racing car full function 27mhz                                                     ",
              "grammage": 0,
              "price": "6.90",
              "price_label": "€ 6,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 27.662178702570394,
                "left": 61.0999592003264,
                "width": 34.686250509995915,
                "height": 16.64626682986536
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/6.90_GLOBO_AUTO_CORSA_RACING_CAR_FULL_FUNCTION_27MHZ__1605785805.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_aKZCYvY_XKtVxaO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239525",
              "field1": "super tombola 24 cartelle",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "super tombola 24 cartelle",
              "grammage": 0,
              "price": "5.90",
              "price_label": "€ 5,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 27.662178702570394,
                "left": 25.46858425132598,
                "width": 34.972970216238274,
                "height": 16.401468788249694
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/5.90_SUPER_TOMBOLA_24_CARTELLE__1605785783.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Z3jSWmN_ZqCdARs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239523",
              "field1": "-cofanetto trucchi cuore                                                                       ",
              "field2": "-carrello spesa in blister",
              "field3": "-fashion doll con mascherina",
              "field4": "-nerf mega thunderhawk",
              "description": "-cofanetto trucchi cuore                                                                        -carrello spesa in blister -fashion doll con mascherina -nerf mega thunderhawk",
              "grammage": 0,
              "price": "3.90",
              "price_label": "€ 3,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 8.200734394124861,
                "left": 25.46858425132598,
                "width": 34.972970216238274,
                "height": 19.461444308445532
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3.90_GLOBO_CARRELLO_SPESA_1605785670.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3.90_GLOBO_COFANETTO_TRUCCHI_CUORE_1605785698.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3.90_GLOBO_GLOBO_FASHION_DOLL_CON_MASCHERINA__1605785719.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/3.90_NERF_MEGA_THUNDERHAWK___1605785736.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_zkVEviI_gSeRnd1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239524",
              "field1": "trousse trucchi cuore doppio",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "trousse trucchi cuore doppio",
              "grammage": 0,
              "price": "4.50",
              "price_label": "€ 4,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 8.200734394124861,
                "left": 60.44155446756425,
                "width": 34.686250509995915,
                "height": 19.461444308445532
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/4.50_GLOBO_TROUSSE_TRUCCHI_CUORE_DOPPIO___1605785766.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ZS1Pu2Z_exfjGCr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 24,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/7029_Superstore_Crotone_Bassa_page-0024_QjEDbYk.jpg",
          "products": [
            {
              "item_id": "239534",
              "field1": "NENUCO CON BIBERON",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "NENUCO CON BIBERON",
              "grammage": 0,
              "price": "13.90",
              "price_label": "€ 13,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Bambole e Peluche",
              "blueprint": {
                "top": 3.2690695725062873,
                "left": 4.580189997205915,
                "width": 23.476040793517754,
                "height": 20.84428726050424
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7007609_1606743994.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ETqZLl4_01DL64a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239533",
              "field1": "nerf  pistola elite shellstrike ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "nerf  pistola elite shellstrike ",
              "grammage": 0,
              "price": "13.90",
              "price_label": "€ 13,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Altro",
              "blueprint": {
                "top": 3.2690695725062873,
                "left": 28.05623079072367,
                "width": 21.252654372729808,
                "height": 20.84428726050424
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/13.90_NERF__PISTOLA_ELITE_SHELLSTRIKE__1605786034.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_07pBhu5_4LU7ZwU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239438",
              "field1": "-lol surprise -trivial pursuit juventus",
              "field2": "gioco da tavolo cards ",
              "field3": "",
              "field4": "",
              "description": "-lol surprise -trivial pursuit juventus gioco da tavolo cards ",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "LOL surprise",
                "Trivial pursuit juventus"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Giochi di Società",
              "blueprint": {
                "top": 3.2690695725062873,
                "left": 59.9499860296172,
                "width": 13.988334730371614,
                "height": 20.592820370311454
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/14.90_GIOCO_DA_TAVOLO_CARDS_LOL_SURPRISE__1605786058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/14.90_GIOCO_DA_TAVOLO_CARDS_TRIVIAL_PURSUIT_JUVENTUS_1605786058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_ufP9IGG_vYQvphH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239439",
              "field1": "-frozen 2 -super mario",
              "field2": "gioco da tavolo cube game",
              "field3": "",
              "field4": "",
              "description": "-frozen 2 -super mario gioco da tavolo cube game",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Frozen 2",
                "Super Mario"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Giochi di Società",
              "blueprint": {
                "top": 3.07396035354699,
                "left": 74.01788208996926,
                "width": 13.176725342274377,
                "height": 11.092007793980256
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/14.90_GIOCO_DA_TAVOLO_CUBE_GAME_FROZEN_2__1605786080.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/14.90_GIOCO_DA_TAVOLO_CUBE_GAME_SUPER_MARIO_1605786080.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_PO0o6YN_azjsZnX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239441",
              "field1": "-gioco da tavolo quiz world football stars",
              "field2": "-puzzle house crests harry potter 500 pezzi                                                          ",
              "field3": "",
              "field4": "",
              "description": "-gioco da tavolo quiz world football stars -puzzle house crests harry potter 500 pezzi                                                          ",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Harry Potter",
                "Marvel cinematic",
                "World football stars"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Giochi di Società",
              "blueprint": {
                "top": 3.3254272437397816,
                "left": 87.18398994132437,
                "width": 11.102612461581446,
                "height": 20.815394214768187
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/14.90_GIOCO_DA_TAVOLO_QUIZ_WORLD_FOOTBALL_STARS___1605786122.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_mxtcJAO_I3dJVgD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239538",
              "field1": "cluedo",
              "field2": "gioco di società",
              "field3": "",
              "field4": "",
              "description": "cluedo gioco di società",
              "grammage": 0,
              "price": "25.90",
              "price_label": "€ 25,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Giochi di Società",
              "blueprint": {
                "top": 24.14082145850797,
                "left": 75.19020676166525,
                "width": 23.096395641240573,
                "height": 19.335485919347498
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/25.90_CLUEDO_GIOCO_DI_SOCIETA____1605786250.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Y4QSLpq_ISJYCLr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239537",
              "field1": "-giochi preziosi sofì bambola doll me contro te cm. 30",
              "field2": "-chicco costruzioni castello 4in1 pz. 70",
              "field3": "",
              "field4": "",
              "description": "-giochi preziosi sofì bambola doll me contro te cm. 30 -chicco costruzioni castello 4in1 pz. 70",
              "grammage": 0,
              "price": "21.50",
              "price_label": "€ 21,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Giochi preziosi",
                "Chicco"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Altro",
              "blueprint": {
                "top": 24.14082145850797,
                "left": 51.573973176865024,
                "width": 23.61623358480023,
                "height": 19.335485919347498
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/21.50_CHICCO_COSTRUZIONI_CASTELLO_4in1_70_PEZZI_1605786202.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/21.50_GIOCHI_PREZIOSI_SOFI_BAMBOLA__DOLL_ME_CONTRO_TE_CM.30_16057862_V7c3com.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Yc41z0w_1x0Usjt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm62718467",
              "field1": "puzzle house crests harry potter 500 pezzi         ",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "puzzle house crests harry potter 500 pezzi         ",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Giochi e Giocattoli",
              "subcategory": "Altro",
              "blueprint": {
                "top": 13.635569741644227,
                "left": 72.84555741827324,
                "width": 11.91422184967868,
                "height": 10.505251716863741
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/1_x65I3Y3.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Zs69zuB_VepvnPH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239536",
              "field1": "bialetti cucina h.69",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "bialetti cucina h.69",
              "grammage": 0,
              "price": "17.90",
              "price_label": "€ 17,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 24.14082145850797,
                "left": 28.03730092204524,
                "width": 23.61623358480023,
                "height": 19.503130512809356
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/17.90_BIALETTI_CUCINA_H.69_1605786180.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_eRVGLiA_Ko17G7e.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239535",
              "field1": "XSTREET AUTO FERRARI RADIOCOMANDATA",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "XSTREET AUTO FERRARI RADIOCOMANDATA",
              "grammage": 0,
              "price": "15.90",
              "price_label": "€ 15,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 24.235006119951052,
                "left": 4.213790289677683,
                "width": 23.756731946144427,
                "height": 19.461444308445532
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7007610_1606744055.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_Z3kIx7A_y3316h1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239539",
              "field1": "-transformer dragonstorm turbo changer",
              "field2": "-fur real orsetto polare",
              "field3": "",
              "field4": "",
              "description": "-transformer dragonstorm turbo changer -fur real orsetto polare",
              "grammage": 0,
              "price": "28.50",
              "price_label": "€ 28,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 43.69645042839659,
                "left": 4.213790289677683,
                "width": 23.756731946144427,
                "height": 21.909424724602204
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/28.50_FUR_REAL_ORSETTO_POLARE_1605786275.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/28.50_TRANSFORMER_DRAGONSTORM_TURBO_CHANGER_1605786276.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_QUwMkSB_sEs0tR4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239540",
              "field1": "na na na 2 in 1 surprise serie 3",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "na na na 2 in 1 surprise serie 3",
              "grammage": 0,
              "price": "34.50",
              "price_label": "€ 34,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 43.69645042839659,
                "left": 27.970522235822106,
                "width": 23.516727866177078,
                "height": 21.909424724602204
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/34.50_NA_NA_NA_2_IN_1_SURPRISE_SERIE_3_1605786317.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_jD3hapE_TtARtzI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "240998",
              "field1": "NENUCO ",
              "field2": "CON BORSA BEBè",
              "field3": "",
              "field4": "",
              "description": "NENUCO  CON BORSA BEBè",
              "grammage": 0,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 43.69645042839659,
                "left": 51.48725010199919,
                "width": 23.361689106487145,
                "height": 21.909424724602204
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/7007638_1606744214.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_6G9rZUp_tx6nWLo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239542",
              "field1": "barbie nuova casa di malibù",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "barbie nuova casa di malibù",
              "grammage": 0,
              "price": "99.90",
              "price_label": "€ 99,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 43.69645042839659,
                "left": 74.84893920848634,
                "width": 22.649122807017545,
                "height": 21.909424724602204
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/99.90_BARBIE_NUOVA_CASA_DI_MALIBU__1605786353.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/products/cropped_image_R6bE4m1_lC3NbD7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 25,
          "image_file": "https://interattivo.s3.amazonaws.com/F5jaVecXHK/pages/fine-superstore-ok_U52rq1c.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.crotone;
}

export const serverResponse = lefletSwitch();